import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common'
import { IMyDpOptions } from 'mydatepicker';
import { BookingsService } from '../bookings.service';
import { Booking, CostAddinItem } from './booking.interface';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../../model/users.model';
import { LocalStorage } from 'ngx-store';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { DispatchService } from 'src/app/services/dispatch.service';
import { ImageResult } from 'ngx-image2dataurl';
import { FilesService } from '../../../services/files.service';


@Component({
  selector: 'app-addbooking',
  templateUrl: './addbooking.component.html',
  styleUrls: ['./addbooking.component.scss'],
  providers: [BookingsService, DatePipe, DispatchService]
})


export class AddbookingComponent implements OnInit {
  @LocalStorage() user: User;
  @ViewChild('modalDispatchRoute', {static: false}) modalDispatchRoute: TemplateRef<any>;


  public bookingFrm: FormGroup; 
  connote: Booking;
  editId: number;
  rebookId: number;
  jobType: any;
  linehaulType: any;
  positions = [];
  public docFile: any;
  showAddDriverForm:boolean = true;
  showAddEquipmentForm: boolean = true;
  showDGForm: boolean = false;
  showPackagingForm: boolean = true;
  showPricingDetailsForm: boolean = true;
  useCompanyBilling: boolean = true;
  serviceTypes: any = [];
  serviceTypesAllowed: any = [];
  // customers: any = [];
  drivers: any = [];
  equipments: any = [];
  trucks: any = [];
  allTrailers: any = [];
  aTrailers: any = [];
  bTrailers: any = [];
  packagingTypes: any =[];
  currentPickupIndex = 0;
  currentDeliveryIndex = 0;
  driver1Id: number;
  driver2Id: number;
  currentDate = new Date();
  tplConnotes: any = [];
  tplConnoteSites: any = [];
  customerTemplates: any = [];
  selectedTemplate: any;
  selectedPickup: any = [];
  selectedDelivery: any = [];
  selectedLocalStart: any = [];
  pointdata: any;
  public mapObj: any;
  public mapLat: any;
  public mapLng: any;
  submitted: boolean = false;
  dispatched: boolean = false;
  states: any;
  termsOfService;
  showPickupTab: boolean = false;
  showDeliveryTab: boolean = false;
  showLocalStartTab: boolean = false;
  showMiscTab: boolean = false;
  makeLocalStartTabActive: boolean = false;
  loadingIndicator = false;
  hasStartSite: boolean = false;
  hasEndSite: boolean = true;
  hasDeliveryEndSite: boolean = true;
  isIncompleteAddress: boolean = false;
  chargingMethods: any = [];
  dgLicenses: any = [];
  editMode: boolean = false;
  editSub: Subscription;
  rebookSub: Subscription;
  serviceCategoryId: number;
  localType: number = 0;
  customerDefaultRates = [];
  isTBAPickup = [];
  isTBADelivery = [];
  costDefaults: any;
  jobCostDefaults: any;

  // Checks Null Opening and CLosing Time
  localStartOpenTimeNull = false;
  pickupOpenTimeNull = false;
  deliveryOpenTimeNull = false;

  // Checks Null Date
  localStartDateNull = false;
  pickupDateNull = false;
  deliveryDateNull = false;
  startDateNull = false;
  endDateNull = false;
  trailerHireStartDateNull = false;
  trailerHireEndDateNull = false;

  // Checks Invalid Time Inputs
  localStartOpeningTimePast = false;
  pickupOpeningTimePast = false;
  deliveryOpeningTimePast = false;
  
  // Check Invalide Date Inputs
  trailerHireDateInvalid = false;
  start_endDateInvalid = false

  // Checks Duplicate Time
  duplicatePickupOpeningTime = false;
  duplicateDeliveryOpeningTime = false;
 
  has_tba : boolean = false;
  route_id : number = null;
  run_routes: [];
  sorted_routes:any;
  public modalRef: NgbModalRef;


  public CUSTOMER_TYPE = {
    EXISTING: 'Existing',
    NEW: 'New'
  };

  public BOOKING_CLASS = {
    ECONOMY: 'economy',
    EXPRESS: 'express'
  }

  public BOOKING_CLASS_LABEL = {
    ECONOMY: 'Economy',
    EXPRESS: 'Express'
  }



  public BOOKING_TYPE = {
    LOCAL: 1,
    LINEHAUL: 2,
    EMPTYRUN: 3,
    TOWHAUL: 4,
    TRAILERHIRE: 5 
  }


  public BOOKING_TYPE_LABEL = {
    LOCAL: 'Local',
    LINEHAUL: 'Linehaul',
    EMPTYRUN: 'Empty Run',
    TOWHAUL: 'Towhaul',
    TRAILERHIRE: 'Fleet Hire' 
  }

  
  public BOOKING_ACTIVITY = {
    PICKUP: 1,
    DELIVERY: 2
  }
  public LOCAL_TYPE = {
    LOCAL_START: 1, 
    PICKUP_DELIVERY: 2
  }

  public LOCAL_TYPE_LABEL = {
    LOCAL_START: 'Local Start', 
    PICKUP_DELIVERY: 'Pickup and Delivery'
  }

  public LINEHAUL_TYPE = {
    FTL: '1',
    LTL: '2'
  }


  public LINEHAUL_TYPE_LABEL = {
    FTL: 'FTL',
    LTL: 'LTL'
  }


  public DG_TYPE = {
    NONE:     0,
    PACKED:   1,
    BULK:     2
  }

  public CHARGING_METHOD_ID = {
    TONNE: '1',
    PALLETS: '2',
    LOAD: '3',
    HOURLY: '4',
    DISTANCE: '5' 
  };

  public SERVICE_TYPE_ABBRV = {
    UTE: 'UTE',
    TWOTONES: '2T4P',
    SEMIPM: 'SemiPM',
    SEMI: 'Semi',
    BDPM: 'BDPM', 
    BDBL: 'BDBL',
    ATRAILER: 'A Trailer', 
    SIXTONES: '6T8P', 
    TWELVETONES: '12T14P', 
    ROADTRAIN: 'Road Train', 
    BTRAILER: 'B Trailer', 
    BDPMA : 'BDPM+A',
    BDPMB: 'BDPM+B', 
    TENPALLETS: '10PR',
    RIGID : 'Rigid',
    TWOTONNE6P: '2T6P',
    SIXTONNE10P: '6T10P',
    EIGHTTTONE12P: '8T12P',
    TWELVETONNE12P: '12T12P',
  }

  public PACKAGING_TYPE_LABELS = {
    PLAINPALLET: 'Plain Pallet',
    CARTON: 'Carton',
    SKID: 'Skid',
    OVERPLAINPALLET: 'Oversized Plain Pallet',
    CHEPPALLET: 'Chep Pallet',
    OVERCHEPPALLET: 'Oversized Chep Pallet',
    LOSCOMPALLET: 'Loscam Pallet',
    OVERLOSCOMPALLET: 'Oversized Loscam Pallet',
  }

  public userSettings: any = {
    showSearchButton: false,
    inputPlaceholderText: 'Type key word on location to search',
    showCurrentLocation: false
  };

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd mmm yyyy',
    height: '25px',
    selectionTxtFontSize: '13px',
    showTodayBtn: true,
    disableUntil: {year: this.currentDate.getFullYear(), month: this.currentDate.getMonth()+1, day: this.currentDate.getDate()-1}

  };

  public customerControlModel: number[];
  public customerControlSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-outline-secondary btn-sm',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    selectionLimit: 1,
    autoUnselect: true,
    closeOnSelect: true,
  };
  public customerControlTexts: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Search Customer',
    defaultTitle: 'Select Customer',
  };
  public customerControlOptions: IMultiSelectOption[];
  public allTrailerControlSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-outline-secondary btn-sm',
    dynamicTitleMaxItems: 10,
    displayAllSelectedText: true,
    autoUnselect: true
  };
  public allTrailerControlTexts: IMultiSelectTexts = {
    uncheckAll: 'Unselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Search Trailers',
    defaultTitle: 'Select Trailers',
  };
  public allTrailerControlOptions: IMultiSelectOption[];

  public customers: IMultiSelectOption[];
  public selectedCustomer: number[] = [];
  public selectedTrailer: any[] = [];
  public currentCustomerId: number;

  public id_residential : number;
  public id_tail_lift : number;
  public id_hand_unload : number;
  public id_extra_site : number;
  public id_trailer_split : number;
  public id_after_hours : number;
  public id_dg : number;
  public id_extra_crew : number;
  public connote_addins : [];
  public cost_addin_item: CostAddinItem;
  public cost_addin_items: CostAddinItem[];
  public rebookdate_adjust: boolean = false;

  public doc_file: any = null;
  public dg_file: any = null;
  public doc_types: any;
  public premise_types: any;

  constructor(private _fb: FormBuilder, private _Activatedroute: ActivatedRoute, private bookingsService: BookingsService, private toastr: ToastrService,  private router: Router, public datePipe: DatePipe,     			private modal: NgbModal, private dispatchService: DispatchService,
    private fileService: FilesService
    ) {
    this.editSub = this._Activatedroute.params.subscribe(params => { this.rebookId = params['rebookId']; });
    this.rebookSub = this._Activatedroute.params.subscribe(params => { this.editId = params['editId']; })
  }

  ngOnInit(): void {
    this.loadingIndicator = true;
    this.packaging_id = 0;

    this.initBookingFrm();
    this.setJobType(this.BOOKING_TYPE.LOCAL);
    this.setLocalType(this.LOCAL_TYPE.LOCAL_START);
    this.setCustomerType(this.CUSTOMER_TYPE.EXISTING);
    this.setServiceType(0);
    this.getAddBookingData();
    console.log('edit id', this.editId);
  
  }

  onCustomerSelect() {
    console.log('selecting');
    const pmCtrl = (<any>this.bookingFrm).controls.customer;
    const existingCtrl = pmCtrl.controls.existing.controls.customerID;
    existingCtrl.setValue(this.currentCustomerId);
    const tplCtrl = pmCtrl.controls.existing.controls.tplConnoteId;

    tplCtrl.setValue(0);

    this.customerTemplates = this.tplConnotes.filter( x => 
      x.customer_id == existingCtrl.value
    );

    console.log(this.customerTemplates);
    this.getCustomerRates(existingCtrl.value);
  }

  public onSelectCustomer(e) {
    this.currentCustomerId = e[0];
    
    const pmCtrl = (<any>this.bookingFrm).controls.customer;
    const existingCtrl = pmCtrl.controls.existing.controls.customerID;
    
    if(existingCtrl.value != null){
      if(existingCtrl.value[0] != '' && existingCtrl.value[0] != null){
        this.onCustomerSelect();
      };
    };
  }

  // Assign in the form of selected trailers when Road Train service
  public onSelectRoadTrainTrailers(e) {
    const items = this.bookingFrm.get('roadTrain_trailers') as FormArray;
    items.clear();
    e.forEach((element, index) => {
      items.push(this._fb.control(e[index]));
    });
  }

  getTplConnoteId() {
        const pmCtrl = (<any>this.bookingFrm).controls.customer;
        const tplCtrl = pmCtrl.controls.existing.controls.tplConnoteId;

        return tplCtrl.value;
  }

  isTemplate() {
    const pmCtrl = (<any>this.bookingFrm).controls.is_template;
    return pmCtrl.value;
  }

 onSelectTemplate() {
   console.log(this.tplConnotes);
   console.log('connote sites',this.tplConnoteSites);
    
    const pmCtrl = (<any>this.bookingFrm).controls.customer;
    const tplCtrl = pmCtrl.controls.existing.controls.tplConnoteId;
    const lsCtrl = (<any>this.bookingFrm).controls.local_start_sites;
    const localStartCtrl = <FormArray>lsCtrl.controls['addresses'];

    const pCtrl = (<any>this.bookingFrm).controls.pickup_sites;
    const pickupCtrl = <FormArray>pCtrl.controls['addresses'];
    const dCtrl = (<any>this.bookingFrm).controls.delivery_sites;
    const deliveryCtrl = <FormArray>dCtrl.controls['addresses'];

    if (tplCtrl.value == '0') {

      pCtrl.reset();
      dCtrl.reset();
      this.setServiceType(0);
      this.setJobType(this.BOOKING_TYPE.LOCAL);
      this.setLocalType(this.LOCAL_TYPE.LOCAL_START);
    } else {
      this.selectedTemplate =  this.customerTemplates.find(x => x.id == tplCtrl.value);
      this.selectedPickup =  this.tplConnoteSites.filter(x => x.connote_id == tplCtrl.value && x.run_action_id == '1');
      this.selectedDelivery =  this.tplConnoteSites.filter(x => x.connote_id == tplCtrl.value && x.run_action_id == '2');
      if (this.getJobType() == this.BOOKING_TYPE.LOCAL) 
        this.selectedLocalStart = this.tplConnoteSites.filter(x => x.connote_id == tplCtrl.value && x.run_action_id == '5');

      console.log('showing selected template');
      console.log(this.selectedTemplate.run_type_id);
      this.setJobType(this.selectedTemplate.run_type_id);
      this.setServiceType(this.selectedTemplate.service_type_id);
      this.setLinehaulType(this.selectedTemplate.linehaul_type_id);
      console.log('job type', this.getJobType());
      if (this.selectedTemplate.linehaul_type_id == '1') this.setLinehaulType(this.LINEHAUL_TYPE.FTL)
        else this.setLinehaulType(this.LINEHAUL_TYPE.LTL)
      
      this.setServiceType(this.selectedTemplate.service_type_id);
      
      // set local start sites from template
      if (this.selectedLocalStart.length > 0){
        this.setLocalType(this.LOCAL_TYPE.LOCAL_START);  
        this.selectedLocalStart.forEach((item, index) => {
          if (index > 0) this.addLocalStartAddress();
            localStartCtrl.controls[index]['controls']['company_name'].setValue(item.company_name);
            localStartCtrl.controls[index]['controls']['street_no'].setValue(item.street_no);
            localStartCtrl.controls[index]['controls']['street'].setValue(item.street);
            localStartCtrl.controls[index]['controls']['suburb'].setValue(item.suburb);
            localStartCtrl.controls[index]['controls']['postal_code'].setValue(item.postal_code);
            localStartCtrl.controls[index]['controls']['state'].setValue(item.state);
            localStartCtrl.controls[index]['controls']['lat'].setValue(item.lat);
            localStartCtrl.controls[index]['controls']['long'].setValue(item.lng);
        });
      }

      if (this.selectedPickup.length > 0){
        this.setLocalType(this.LOCAL_TYPE.PICKUP_DELIVERY);
      }

      // set pickup addresses
      this.selectedPickup.forEach((item, index) => {
        if (index > 0) this.addPickupAddress();
          pickupCtrl.controls[index]['controls']['company_name'].setValue(item.company_name);
          pickupCtrl.controls[index]['controls']['street_no'].setValue(item.street_no);
          pickupCtrl.controls[index]['controls']['street'].setValue(item.street);
          pickupCtrl.controls[index]['controls']['suburb'].setValue(item.suburb);
          pickupCtrl.controls[index]['controls']['postal_code'].setValue(item.postal_code);
          pickupCtrl.controls[index]['controls']['state'].setValue(item.state);
          pickupCtrl.controls[index]['controls']['lat'].setValue(item.lat);
          pickupCtrl.controls[index]['controls']['long'].setValue(item.lng);

      });

      // set delivery addresses
      if (this.selectedDelivery.length > 0)
      this.selectedDelivery.forEach((item, index) => {
        if (index > 0) this.addDeliveryAddress();
          deliveryCtrl.controls[index]['controls']['company_name'].setValue(item.company_name);
          deliveryCtrl.controls[index]['controls']['street_no'].setValue(item.street_no);
          deliveryCtrl.controls[index]['controls']['street'].setValue(item.street);
          deliveryCtrl.controls[index]['controls']['suburb'].setValue(item.suburb);
          deliveryCtrl.controls[index]['controls']['postal_code'].setValue(item.postal_code);
          deliveryCtrl.controls[index]['controls']['state'].setValue(item.state);
          deliveryCtrl.controls[index]['controls']['lat'].setValue(item.lat);
          deliveryCtrl.controls[index]['controls']['long'].setValue(item.lng);

      });
  
    }

    if((<any>this.bookingFrm).controls.service_type_id.value != null){
      this.setServiceCategory((<any>this.bookingFrm).controls.service_type_id.value, 'edit');
    }
    


 }

  getAddBookingData() {
      this.bookingsService.getAddBookingData().subscribe( data => {
        this.doc_types = data['doc_types'];
        this.serviceTypes = data['service_types'];
        this.serviceTypesAllowed = data['service_types_allowed'];
        // this.customers = data['customers'];
        // this.customerControlOptions = this.customers;
        this.drivers = data['drivers'];
        this.premise_types = data['premise_types'];

      if(this.rebookId || (!this.editId && !this.rebookId)){ //remove archived fleets and customers if rebooking or add booking
        let equipments_temp = [];
        equipments_temp = data['equipments'].filter(equipment => { return equipment.deleted_date == null});
        this.equipments = equipments_temp;

        let customers_temp = [];
        customers_temp = data['customers'].filter(customer => { return customer.deleted_date == null });
        this.customers = customers_temp;
        this.customerControlOptions = this.customers;
      }
      else{ //all fleets and customers in edit booking
        this.equipments = data['equipments']; 
        this.customers = data['customers'];
        this.customerControlOptions = this.customers;
      }

        this.tplConnotes = data['tpl_connotes'];
        this.tplConnoteSites = data['tpl_connote_sites'];
        this.packagingTypes = data['packaging_types'];
        this.dgLicenses = data['dg_licenses'];
        this.run_routes = data['run_routes'];
        this.termsOfService = data['terms_of_service'];
        this.costDefaults =  data['job_cost_defaults'];
        this.jobCostDefaults = data['job_cost_defaults'];
        console.log('default rates', this.costDefaults);
        console.log('dglic', this.dgLicenses);
        console.log('sv', data['service_types_allowed']);
        this.trucks = this.equipments.filter( x => 
          x.equipment_type_id != '4'
        );
        this.states = data['states'];
        this.chargingMethods = data['charging_methods'];
        this.connote_addins = data['connote_addins'];
        this.setAddinVariables();

        this.aTrailers = this.equipments.filter( x => 
          x.equipment_type_id == '4' &&  x.equipment_subtype_id == '4'
        );

        this.bTrailers = this.equipments.filter( x => 
          x.equipment_type_id == '4' &&  x.equipment_subtype_id == '5'
        );

        this.allTrailers = this.equipments.filter(x => x.equipment_type_id == '4');
        this.allTrailerControlOptions = this.allTrailers;
        // Assign name of rego than fleet_id_num in the options
        for(let i =0; i<this.allTrailers.length;i++){
          this.allTrailerControlOptions[i]['name'] = this.allTrailers[i]['equipment_rego'];
        }
        
        this.drivers = data['drivers'];

        console.log(data);

        //moved here to load booking data first
        if (this.editId) {
          this.getEditBookingData(this.editId, 'edit');
        } else if (this.rebookId){
          this.getEditBookingData(this.rebookId, 'rebook');
        }else{
          this.loadingIndicator = false;
        };

    });
  }

  
  /**
   * Get the applicable drivers from the selected Service Type
   * @param drivers  Contains the list of all active drivers
   * @param type  Contains the id of the service type
   * @returns List of applicable drivers (thru their licence) that matches the service type
   */
  getDriversByServiceType(drivers, type){
    let newList = [];
    drivers.forEach(driver=>{
      let isApplicable = this.dispatchService.checkDriverLicence(type, driver.license_class_id);
      if(isApplicable) newList.push(driver);
    });
    return newList;
  }
  
  /**
   * Assign a prime mover service when it is LTL
   * @param type Contains the selected Linehaul Type
   * @returns A service type ID
   */
  checkLinehaulType(type){
    if(this.linehaulType == 2 && type == 0) type = 3;
    return type;
  }

  /**
   * Check the change on selection of service type
   * @param type Contains the id of the service type
   * @returns List of applicable drivers
   */
  serviceTypeValueChange(type){
    let verifiedType = this.checkLinehaulType(type);
    if(verifiedType != 0){
      return this.getDriversByServiceType(this.drivers, verifiedType);
    }else{
      this.setDriver1(null);
      this.setDriver2(null);
      return [];
    }
  }


  async getEditBookingData(editId, type) {
    this.rebookdate_adjust = false;
    this.loadingIndicator = true;
    const pCtrl = (<any>this.bookingFrm);
    const pmCtrl = (<any>this.bookingFrm).controls.customer;
    const existingCtrl = pmCtrl.controls.existing.controls.customerID;
    
    const billCtrl = pCtrl.controls.bill_to;
    const sCtrl = (<any>this.bookingFrm).controls.dgClass.controls.subsidiaries;
      const formArray: FormArray = this.bookingFrm.get('dgClass.subsidiaries') as FormArray;

    await this.bookingsService.getEditBookingData(editId).toPromise().then( data => {
      this.connote = data['connote'];
      this.getCustomerRates(this.connote.customer_id);
      
      this.serviceTypes.forEach((e: any) => {
        if (e.id == this.connote.service_type_id)
            this.serviceCategoryId = e.service_category_id;
      });
      
      //this.connote.customer.existing.customerID = data['connote']['customer_id'];
      console.log('edit booking: ', this.connote);
      var pkLength = this.connote.packagings.length;
      var lsLength = 0;
      if (this.connote.is_dg && this.connote.job_type_id != 4) {
        this.showDGForm = true;
      }
      if(this.connote.job_type_id != 3 &&  this.connote.job_type_id != 5){
        var pLength = this.connote.pickup_sites['addresses'].length;
        var dLength = this.connote.delivery_sites['addresses'].length;
      } else {
        pLength = 0; dLength = 0;
      }
      if(this.connote.job_type_id == 1){
        lsLength = this.connote.local_start_sites['addresses'].length;
        (this.connote.local_start_sites['addresses'].length == 0)? this.localType = this.LOCAL_TYPE.PICKUP_DELIVERY: this.localType = this.LOCAL_TYPE.LOCAL_START;
      }

      for (let count = 1; count < pLength; count++)
        this.addPickupAddress();

      for (let count = 1; count < dLength; count++)
        this.addDeliveryAddress();
      
      for (let count = 1; count < pkLength; count++) {
        this.addPackaging();
      }
      
      existingCtrl.setValue(this.connote.customer_id);
      //billCtrl.controls.company.setValue = this.connote.bill_to_company;
      if (this.connote.bill_to.company) {
        this.useCompanyBilling = false; 
        var element = <HTMLInputElement> document.getElementById("billCheck")
        element.checked = false;
      }
      
      if(pLength != 0) {
        for (let count = 0; count < pLength; count++) {
          let d: Date = new Date(this.connote.pickup_sites['addresses'][count].opening_datetime);
          let d2: Date = new Date(this.connote.pickup_sites['addresses'][count].closing_datetime);

          let finalDate;
          if (type == 'rebook'){
            let today = new Date();
            if((d <= today || d2 <= today)){
              this.rebookdate_adjust = true;
              finalDate = this.getbookingDateTime(today,today);  
            } else finalDate = this.getbookingDateTime(d,d2);  
        } else finalDate = this.getbookingDateTime(d,d2);  

          this.connote.pickup_sites['addresses'][count]['date'] = finalDate.date
          this.connote.pickup_sites['addresses'][count]['opening_time'] = finalDate.op
          this.connote.pickup_sites['addresses'][count]['closing_time'] = finalDate.cls
        }
      }
      
      if(dLength != 0) {
        for (let count = 0; count < dLength; count++) {

          if(this.connote.delivery_sites['addresses'][count].location_id == null ){
            this.connote.delivery_sites['addresses'][count].is_tba = true;
          }//TBA Delivery

          let d: Date = new Date(this.connote.delivery_sites['addresses'][count].opening_datetime);
          let d2: Date = new Date(this.connote.delivery_sites['addresses'][count].closing_datetime);
          let finalDate;
          if (type == 'rebook'){
            let today = new Date();
            if((d <= today || d2 <= today)){
              this.rebookdate_adjust = true;
              finalDate = this.getbookingDateTime(today,today);
            } else finalDate = this.getbookingDateTime(d,d2);  
        } else finalDate = this.getbookingDateTime(d,d2);  
  
          this.connote.delivery_sites['addresses'][count]['date'] = finalDate.date
          this.connote.delivery_sites['addresses'][count]['opening_time'] = finalDate.op
          this.connote.delivery_sites['addresses'][count]['closing_time'] = finalDate.cls
        }
      }

      if(lsLength != 0) {
        for (let count = 0; count < lsLength; count++) {
          let d: Date = new Date(this.connote.local_start_sites['addresses'][count].opening_datetime);
          let d2: Date = new Date(this.connote.local_start_sites['addresses'][count].closing_datetime);
  
          let finalDate;
          if (type == 'rebook'){
              let today = new Date();
              if((d <= today || d2 <= today)){
                this.rebookdate_adjust = true;
                finalDate = this.getbookingDateTime(today,today);  
              } else finalDate = this.getbookingDateTime(d,d2);  
          } else finalDate = this.getbookingDateTime(d,d2);  
  
          this.connote.local_start_sites['addresses'][count]['date'] = finalDate.date
          this.connote.local_start_sites['addresses'][count]['opening_time'] = finalDate.op
          this.connote.local_start_sites['addresses'][count]['closing_time'] = finalDate.cls
        }
      }

      if(this.connote.job_type_id == 3){
        let d = new Date(this.connote['start_site']['opening_datetime']);
        let d2 = new Date(this.connote['start_site']['closing_datetime']);
        let dd = new Date(this.connote['end_site']['opening_datetime']);
        let dd2 = new Date(this.connote['end_site']['closing_datetime']);

        let finalDate, finalDate2;
        if (type == 'rebook'){

            let today = new Date();
            if((d <= today || d2 <= today) || (dd<= today || dd2<= today)){
              this.rebookdate_adjust = true;
              finalDate = this.getbookingDateTime(today,today);  
              finalDate2 = this.getbookingDateTime(today,today);
            } else {
              finalDate = this.getbookingDateTime(d,d2);  
              finalDate2 = this.getbookingDateTime(dd,dd2);
            }
    
        } else {
          finalDate = this.getbookingDateTime(d,d2);  
          finalDate2 = this.getbookingDateTime(dd,dd2);
        }
        
        this.connote['start_site']['date'] = finalDate.date
        this.connote['start_site']['opening_time'] = finalDate.op
        this.connote['start_site']['closing_time']= finalDate.cls
        this.connote['end_site']['date'] = finalDate2.date
        this.connote['end_site']['opening_time'] = finalDate2.op
        this.connote['end_site']['closing_time']= finalDate2.cls 
        console.log(this.bookingFrm)
      }
      
      if(type == 'rebook'){
        //if booked with archived fleet, do not show the archived fleet in the selection and reset the truck and trailers id
        if(this.connote.truck_id != 0){
          let isFound = this.equipments.filter((data) => { return data.id == this.connote.truck_id });

          //archived
          if(isFound.length == 0) this.connote.truck_id = 0;
        }

        if(this.connote.trailerA_id != 0){
          let isFound = this.equipments.filter((data) => { return data.id == this.connote.trailerA_id });

          //archived
          if(isFound.length == 0) this.connote.trailerA_id = 0;
        }

        if(this.connote.trailerB_id != 0){
          let isFound = this.equipments.filter((data) => { return data.id == this.connote.trailerB_id });

          //archived
          if(isFound.length == 0) this.connote.trailerB_id = 0;
        }

        //if booked with archived customer, do not show the archived customer in the selection and reset the customer id
        if(this.connote.customer_id != 0){
          let isFound = this.customers.filter((data) => { return data.id == this.connote.customer_id });
          
          //archived
          if(isFound.length == 0){
            this.connote.customer_id = 0;
            this.bookingFrm.get('customer').get('existing').patchValue({ customerID: [] });
          }
        }
      }
      else if(type == 'edit'){
        // if booked with unarchived fleet, do not show the archived fleet in the selection and do not reset the truck and trailers id
        if(this.connote.truck_id != 0){
          let isFound = this.equipments.filter((data) => { return data.id == this.connote.truck_id });

          if(isFound.length > 0){
            if(isFound[0].deleted_date == null){ //unarchived fleet
              let equipments_temp = this.equipments.filter(data => { return data.deleted_date == null && data.equipment_type_id != 4 }); 
              this.trucks = equipments_temp;
            }
            else{ //archived fleet
              let equipments_temp = this.equipments.filter(data => { return data.deleted_date == null && data.equipment_type_id != 4 || data.id == this.connote.truck_id });
              this.trucks = equipments_temp;
            }
          }
        }

        if(this.connote.trailerA_id != 0){
          let isFound = this.equipments.filter((data) => { return data.id == this.connote.trailerA_id });

          if(isFound.length > 0){
            if(isFound[0].deleted_date == null){ //unarchived fleet
              let equipments_temp = this.equipments.filter(data => { return data.deleted_date == null && data.equipment_type_id == 4 && data.equipment_subtype_id == 4 }); 
              this.aTrailers = equipments_temp;
            }
            else{ //archived fleet
              let equipments_temp = this.equipments.filter(data => { return data.deleted_date == null && data.equipment_type_id == 4 && data.equipment_subtype_id == 4 || data.id == this.connote.trailerA_id});
              this.aTrailers = equipments_temp;
            }
          }
        }

        if(this.connote.trailerB_id != 0){
          let isFound = this.equipments.filter((data) => { return data.id == this.connote.trailerB_id });

          if(isFound.length > 0){
            if(isFound[0].deleted_date == null){ //unarchived fleet
              let equipments_temp = this.equipments.filter(data => { return data.deleted_date == null && data.equipment_type_id == 4 && data.equipment_subtype_id == 5 }); 
              this.bTrailers = equipments_temp;
            }
            else{ //archived fleet
              let equipments_temp = this.equipments.filter(data => { return data.deleted_date == null && data.equipment_type_id == 4 && data.equipment_subtype_id == 5 || data.id == this.connote.trailerB_id });
              this.bTrailers = equipments_temp;
            }
          }
        }

        //if booked with unarchived customer, do not show the archived customer in the selection and do not reset the customer id
        if(this.connote.customer_id != 0){
          let isFound = this.customers.filter((data) => { return data.id == this.connote.customer_id });
          
          if(isFound.length > 0){
            if(isFound[0]['deleted_date'] == null){ //unarchived customer
              let customers_temp = this.customers.filter(data => { return data['deleted_date'] == null });
              this.customers = customers_temp;
              this.customerControlOptions = this.customers;
            }
            else{ //archived customer
              let customers_temp = this.customers.filter(data => { return data['deleted_date'] == null || data['id'] == this.connote.customer_id });
              this.customers = customers_temp;
              this.customerControlOptions = this.customers;
            }
          }
        }     
      }
      this.bookingFrm.patchValue(this.connote);

      if(this.connote.service_type_id != null){
        this.setServiceCategory(this.connote.service_type_id.toString(), 'edit');
      };

      // Assign in the form of selected trailers when Road Train service
      if(this.connote.service_type_id == 10){
        this.selectedTrailer =  this.connote.roadTrain_trailers 
        this.onSelectRoadTrainTrailers(this.selectedTrailer);
      }else{
        this.selectedTrailer = [];
      }
      
      let lt_label = '';
      this.connote.linehaul_type_id == null? lt_label = '': lt_label = this.connote.linehaul_type_id.toString();
      this.setLinehaulType(lt_label);
      this.loadingIndicator = false;

      if(this.connote.dgClass){
        this.connote.dgClass.subsidiaries.forEach((s) => {
          formArray.push(new FormControl(s));
        });
        sCtrl.setValue(this.connote.dgClass.subsidiaries);
      }


      for (let count = 0; count < pkLength; count++  ) {
        this.assignTotalWeight(count, 'component');
      }

      if(this.connote.total_cost >0){
        this.bookingFrm.controls.total_cost.setValue(this.connote.total_cost);
      }

      //setting pallet_units, distance and hour units.
      this.pallet_units = this.connote.pallet;
      this.computed_hrs = this.connote.est_total_hours;
      this.computed_klms = this.connote.total_klms;
      this.computeTotalCost();
      
      console.log('patchedFrm', this.bookingFrm); //log to see form values on screen

      this.checkServiceType(this.editId);

      if(this.rebookdate_adjust){
        this.toastr.success("Date & Time adjusted", "", {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      };

      //assign plc_packagings with packagings data
      const pCtrl = (<any>this.bookingFrm).controls.packagings;
      this.plc_packagings = pCtrl.value;
    });
  }

  getbookingDateTime(d, d2){
    for(var i=1 ;i<=4;i++)
    {
        var quarter_min = Math.ceil((d.getMinutes() / 15)) *15 +(i*15);
        var quarter_min2 = Math.ceil((d2.getMinutes() / 15)) *15 +(i*15);
        var timeA = new Date(d.getTime() + (quarter_min - d.getMinutes()) *60000);
        var timeB = new Date(d2.getTime() + (quarter_min2 - d2.getMinutes()) *60000);
    }

    var hours = (timeA.getHours()%24) -1; var hoursb = (timeB.getHours()%24) -1;
    var minutes = timeA.getMinutes(); var minutesb = timeB.getMinutes();
    if (hours == -1) hours = 23; if (hoursb == -1) hoursb = 23;
  
    let date = {date:{year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()}}
    let op = {hour: hours , minute: minutes};
    let cls = {hour: hoursb , minute: minutesb};
    return({date,op,cls});
  }

  getRebookingData(rebookId) {
    console.log('rebooking');
  }

  initBookingFrm() {

    // const currencyRegex = '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
    // const floatRegex = '^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$'; 
  
    const currencyRegex = '^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{1,2})?$';
    const floatRegex = '^[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$'; 
    
    let d: Date = new Date();

    this.bookingFrm = this._fb.group({
      id: [null],
      is_template: [false],
      template_name: [''],
      job_type_id:[1],
      linehaul_type_id: [''],
      service_type_id: [0],
      driver1_id: [null],
      driver2_id:  [null],
      truck_id: [0],
      trailerA_id: [0],
      trailerB_id: [0],
      trailerC_id: [0],
      trailerD_id: [0],
      trailerE_id: [0],
      trailerF_id: [0],
      roadTrain_trailers: this._fb.array([]),
      service_option: ['economy'],
      customer_reference_no: [''],
      charging_method_id: [this.CHARGING_METHOD_ID.LOAD],
      price: ['', [Validators.pattern(currencyRegex)]],
      fuel_levy: [0, [Validators.pattern(floatRegex)]],
      service_fee: [0, [Validators.pattern(floatRegex)]],
      is_dg: [false],
      dgClass: this.initDGClassesGroup(),
      start_site: this.initAddress(14),  // initialize to an empty run start site: 14
      end_site: this.initAddress(15),    // initialize to an empty run end site: 15
      trailer_hire_start: [{date: {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()}}], 
      trailer_hire_end: [{date: {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()}}], 
      local_start_sites: this.initLocalStartSitesGroup(),
      pickup_sites: this.initPickupSitesGroup(),
      delivery_sites: this.initDeliverySitesGroup(),
      customer: this.initCustomerFormGroup(),
      use_company_billing: [true],
      bill_to: this.initBillToFormGroup(),
      created_by: this.user.id,
      packagings: this._fb.array([
        this.initPackagings(),
      ]),
      has_tba: [0],
      run_route_id: [''],
      total_cost: [0],
      tonnes:[1],
      pallet:[1],
      total_klms:[0],
      est_total_hours:[0],
      other_cost:[0],
      loads:[1],
      minimum_hours:[1],
      special_instructions:[''],
      addin_items:this._fb.array([
        this.initAddinItem(),
      ]),
    });

    //this.onFormChange();
    this.other_cost_description = '';
    console.log('GO GO GO');
    console.log(this.bookingFrm);

  }

  // public onFormChange(){
  //   this.bookingFrm.controls.packagings.valueChanges.subscribe(change => {
  //     this.getBookingWeight();
  //     this.getBookingPallets();
  //     this.computeTotalCost();
  //   });
    
  //   this.bookingFrm.controls.pickup_sites.get('addresses').valueChanges.subscribe(change => {
  //     if(this.getChargingMethodID() == this.CHARGING_METHOD_ID.DISTANCE || this.getChargingMethodID() == this.CHARGING_METHOD_ID.HOURLY){
  //       this.getKlmsHrs();
  //       this.computeTotalCost();
  //     }
  //   });

  //   this.bookingFrm.controls.delivery_sites.get('addresses').valueChanges.subscribe(change => {
  //     if(this.getChargingMethodID() == this.CHARGING_METHOD_ID.DISTANCE || this.getChargingMethodID() == this.CHARGING_METHOD_ID.HOURLY){
  //       this.getKlmsHrs();
  //       this.computeTotalCost();
  //     }
  //   });
    
  // }

  public recomputeForm(){
    this.getBookingWeight();
    this.getBookingPallets('component');

    if(this.getChargingMethodID() == this.CHARGING_METHOD_ID.DISTANCE || this.getChargingMethodID() == this.CHARGING_METHOD_ID.HOURLY){
      this.getKlmsHrs();
    };

    this.computeTotalCost();
  }

  initDGClassesGroup() {
    const group = this._fb.group({
        dg_class_id: [''],
        dg_type_id: ['1'],
        dg_file: [''],
        subsidiaries: this._fb.array([]),
     });

    return group; 
}
  initCustomerFormGroup() {
    // initialize payment method form group
     const group = this._fb.group({
            type: [''],
            existing: this._fb.group(this.initCustomerExistingModel()),
            new: this._fb.group(this.initCustomerNewModel()),
      });

    return group;
}


initCustomerNewModel() {
  // initialize card model
  const model = {
      companyName: [''],
      contactName: [''],
      contactNumber: ['']
  };

  return model;
}

initBillToFormGroup() {
  const group = this._fb.group({
    company: [''],
    address: [''],
    email: [''],
    contact_no: ['']
});

return group;
}


initCustomerExistingModel() {
  // initialize Existing Customer model
  const model = {
      customerID: [0],
      tplConnoteId: ['']

  };

  return model;
}

initLocalStartSitesGroup() {

  const group = this._fb.group({
         addresses: this._fb.array([
             this.initAddress(5),
         ])
   });
  return group; 
}

public onTBAChange(data, activityType){
  this.isTBAPickup = [];

  data.addresses.forEach((element, index) => {
    if(activityType == 1){
      this.isTBAPickup.push(element.is_tba);
    }
    // else if(activityType == 2){
    //   this.isTBADelivery.push(element.is_tba);
    //   if(data.addresses[index].is_tba){
    //     console.log("TBA Delivery is active");
    //     // console.log("Delivery Address", (<any>this.bookingFrm).controls.delivery_sites.controls['addresses']);
        
    //     (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.postal_code.patchValue('', {emitEvent: false});
    //     (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.state.patchValue('', {emitEvent: false});
    //     (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.state_id.patchValue('', {emitEvent: false});
    //     (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.suburb.patchValue('', {emitEvent: false});
    //     (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.street.patchValue('', {emitEvent: false});
    //     (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.street_no.patchValue('', {emitEvent: false});
    //   }
    // }

  });
}

public onTBAChangeDelivery(data){
  this.isTBADelivery = [];

  data.addresses.forEach((element, index) => {
    this.isTBADelivery.push(element.is_tba);
    if(data.addresses[index].is_tba){
      console.log("TBA Delivery is active");
      console.log("Delivery Address", (<any>this.bookingFrm).controls.delivery_sites.controls['addresses']);
      
      (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.postal_code.patchValue('', {emitEvent: false});
      (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.state.patchValue('', {emitEvent: false});
      (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.state_id.patchValue('', {emitEvent: false});
      (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.suburb.patchValue('', {emitEvent: false});
      (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.street.patchValue('', {emitEvent: false});
      (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].controls[index].controls.street_no.patchValue('', {emitEvent: false});
    }
  });
}

initPickupSitesGroup() {

  const group = this._fb.group({
         addresses: this._fb.array([
             this.initAddress(1),
         ])
   });

  group.valueChanges.subscribe(data=> this.onTBAChange(data, 1));
  return group; 
}


initDeliverySitesGroup() {

  const group = this._fb.group({
         addresses: this._fb.array([
             this.initAddress(2),
         ])

   });

  group.valueChanges.subscribe(data=> this.onTBAChangeDelivery(data));
  return group; 
}




initAddress($activityTypeId: number) {
  let d: Date = new Date();

  for(var i=1 ;i<=4;i++)
  {
      var quarter_min = Math.ceil((d.getMinutes() / 15)) *15 +(i*15);
      var d2 = new Date(d.getTime() + (quarter_min - d.getMinutes()) *60000);
  }

  var hours = (d2.getHours()%24) -1;
  var minutes = d2.getMinutes();
  if (hours == -1) hours = 11;
  if($activityTypeId == 15){
    if(minutes == 45){ //45 + 15 = 60 (add another hour)
      if(hours == 23){ // 23 + 1 = 24 (add another day)
        d.setDate(d.getDate() + 1); //+1 day
      } else {
        hours = hours + 1; // + 1 hour
        minutes = 0; //resets to 00
      }
    } else minutes = minutes + 15; //15 minute interval
  }
  
  // initialize our address
  return this._fb.group({
    
      id: [''],
      location_string: [''],
      lat: [''],
      long: [''],
      street_no: [{value: '', disabled: true}],
      street: [{value: '', disabled: true}],
      suburb: [{value: '', disabled: true}],
      state: [''],
      state_id: [''],
      postal_code: [{value: '', disabled: true}],
      activity_type_id: [$activityTypeId],
      date: [{date: {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()}}], 
      opening_time: [{hour: hours , minute: minutes}],
      closing_time: [{hour: hours , minute: minutes}],
      company_name: [''],
      contact_name: [''],
      contact_no: [''],
      contact_email: [''],
      is_direct: [false],
      is_tail_lift: [false],
      is_hand_unload: [false],
      is_trailer_split: [false],
      is_extra_crew: [false],
      is_holding_overnight: [false],
      is_tailgate: [false],
      is_residential: [false],
      is_futile: [false],
      is_tba: [false],
      is_atl: [false],
      //is_guaranteed: [false],

      driver_id: [''],
      status_id: [''],
      order_no: [''],
      unit: [''],
      amount: [''],
      file: [''],
      notes: [''],

      business_open_time: [''],
      business_close_time: [''],
      packagings:[''],
      premise_type_id:[2]
  });
}


/* initPackagingGroup() {
  this.bookingFrm.addControl('packagings', this._fb.array([this.initPackagings()]));

});

return group; 
} */


initAddinItem() {
  const group = this._fb.group({
      connote_id: [''],
      connote_addin_id : [''],
      description: [''],
      units: [0],
      cost: [0.00],
      created_by: [this.user.id],
  });

  return group;
}

initPackagings() {
  const currencyRegex = '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
  const floatRegex = '^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$'; 
  const intRegex = '^[0-9]{1,6}$';

  this.packaging_id +=1;
  const group = this._fb.group({
      packaging_id: [this.packaging_id],
      packaging_type_id: [0],
      packaging_type_name:[''],
      quantity: ['', [Validators.pattern(intRegex)]],
      length: ['', [Validators.pattern(floatRegex)]],
      width: ['', [Validators.pattern(floatRegex)]],
      height: ['', [Validators.pattern(floatRegex)]],
      weight: ['', [Validators.pattern(floatRegex)]],
      total_weight: [''],
      db_id:[''],
  });
  
  return group;
}

addPackaging() {
    // add address to the list
    //console.log('adding additional packaging');
    const pCtrl = (<any>this.bookingFrm).controls.packagings;


    pCtrl.push(this.initPackagings());
    let index = pCtrl.length - 1;

    this.plc_packagings= pCtrl.value;
    
    
}  // END ADD ADDRESS


removePackaging(i: number) {
    // remove address from the list
    const pCtrl = (<any>this.bookingFrm).controls.packagings;
    let p_id = pCtrl.controls[i].controls.packaging_id.value;
    pCtrl.removeAt(i);
    this.positions.splice(i, 1);
    this.getBookingPallets('packaging');this.getBookingWeight();

    this.plc_packagings= pCtrl.value;

    this.removeSitesPackages(this.plc_packagings, p_id);

}
// END REMOVE PACKAGINGS

assignTotalWeight(i: number, caller) {
      // remove address from the list
      const pCtrl = (<any>this.bookingFrm).controls.packagings.controls[i];
      if (pCtrl.controls['weight'].value)
          var weight = parseFloat(pCtrl.controls['weight'].value);
      else var weight = 0;
      if (pCtrl.controls['quantity'].value)
          var quantity = parseInt(pCtrl.controls['quantity'].value);
      else var quantity = 0;

      if (quantity && weight) {
          var number = quantity * weight;
          pCtrl.controls['total_weight'].setValue(number);

      }

      this.getBookingPallets(caller);this.getBookingWeight();

      //refresh plc_packagings per packagings display per site
      this.plc_packagings = (<any>this.bookingFrm).controls.packagings.value;
          
}

public weight = 0;
public tonne =0;
getBookingWeight() {
  const pCtrl = (<any>this.bookingFrm).controls.packagings.controls;
  this.weight = 0;

  pCtrl.forEach((item) => {
    if(item.controls.total_weight) {
     this.weight = this.weight + item.controls.total_weight.value;
      
    }
  });
  this.tonne = this.weight/1000;

  //return weight;
}

getPackagingCubicWeight() {

}

public totalChargeablePallets =0; 
public totalChargeableWeight =0; 
public totalWeightKg =0; 
public pallet_units:  number = 0;
public total_qty :number= 0;
public is_unit_auto_compute = true;
getBookingPallets(caller) {
  const pCtrl = (<any>this.bookingFrm).controls.packagings.controls;
  this.totalChargeablePallets = 0;
  this.totalChargeableWeight =0; 
  this.totalWeightKg = 0;
  this.pallet_units = 0;
  this.total_qty = 0;
  var cubic_weight_param = 333;
  if(this.costDefaults.cubic_weight_param != null){
    cubic_weight_param = this.costDefaults.cubic_weight_param;
  };

  var max_weight_param = 0;
  if(this.costDefaults.pallet_max_weight != null){
    max_weight_param = this.costDefaults.pallet_max_weight;
  }

  pCtrl.forEach((item) => {
    
    if(item.controls.length.value && item.controls.width.value && item.controls.height.value && item.controls.quantity.value && item.controls.weight.value) {
      if(item.controls.quantity.value){this.total_qty += parseFloat(item.controls.quantity.value)};
      var volume = item.controls.quantity.value * ( (item.controls.length.value/100) * (item.controls.width.value/100) * (item.controls.height.value)/100 );
      var cubicWeight = volume * cubic_weight_param;
      var physicalWeight = item.controls.total_weight.value;
      var chargeWeight = parseFloat((cubicWeight / max_weight_param).toFixed(2));
            
      var chargeablePallets = Math.max(item.controls.quantity.value,chargeWeight);
      
      this.totalChargeablePallets = this.totalChargeablePallets + chargeablePallets;

      var chargeableWeight = Math.max(physicalWeight, cubicWeight);
      console.log(chargeableWeight, item.controls.total_weight.value, 'weight');
      this.totalChargeableWeight = this.totalChargeableWeight + chargeableWeight;

      // var tonne_weight = item.controls.weight.value/1000;
      // this.totalWeightKg = this.totalWeightKg + tonne_weight;
    }
  });
  
  if(this.totalChargeablePallets > 0)
  {
    this.totalChargeablePallets = parseFloat(this.totalChargeablePallets.toFixed(2));
  } 
  
  this.totalChargeablePallets = Math.ceil(this.totalChargeablePallets);
  
  if(this.is_unit_auto_compute == true || caller == 'user'){
    // this.bookingFrm.controls.pallet.setValue(0);
    if(this.total_qty < this.totalChargeablePallets){// only set chargeable pallet to pallet units if it is greater in value
      this.bookingFrm.controls.pallet.setValue(this.totalChargeablePallets);
      this.pallet_units = this.totalChargeablePallets;
    }else{
      this.bookingFrm.controls.pallet.setValue(this.total_qty);
      this.pallet_units = this.total_qty;
    };
  }
  
  if(this.is_unit_auto_compute == true || caller == 'user'){
    this.bookingFrm.controls.tonnes.setValue(this.totalChargeableWeight.toFixed(2));
  };

  //return this.totalChargeablePallets;
}


getPackagingControl() {
  const pCtrl = (<any>this.bookingFrm).controls.packagings;
  
  return pCtrl.controls;
}

showPackagingRemoveIcon() {
  if (this.getPackagingControl().length > 1)
      return true;
  else return false;
}

showPackagingClearIcon() {
  if (this.getPackagingControl().length == 1)
      return true;
  else return false;
}

addLocalStartAddress() {
  // add address to the list
  console.log('adding additional address');
  const ptCtrl = (<any>this.bookingFrm).controls.local_start_sites;
  const control = <FormArray>ptCtrl.controls['addresses'];
  var activityTypeId: number;
  control.push(this.initAddress(5));
  let index = control.length - 1;
  this.currentPickupIndex = index;
}  // END ADD ADDRESS



addPickupAddress() {
  // add address to the list
  console.log('adding additional address');
  const ptCtrl = (<any>this.bookingFrm).controls.pickup_sites;
  const control = <FormArray>ptCtrl.controls['addresses'];
  var activityTypeId: number;
  control.push(this.initAddress(1));
  let index = control.length - 1;
  this.currentPickupIndex = index;
}  // END ADD ADDRESS


addDeliveryAddress() {
  // add address to the list
  const ptCtrl = (<any>this.bookingFrm).controls.delivery_sites;
  const control = <FormArray>ptCtrl.controls['addresses'];
  control.push(this.initAddress(2));
  let index = control.length - 1;
  
  this.currentDeliveryIndex = index;

}


removePickupAddress(i: number) {
  // remove address from the list
  const remCtrl = (<any>this.bookingFrm).controls.pickup_sites;
  const control = <FormArray>remCtrl.controls['addresses'];
  control.removeAt(i);
}

removeDeliveryAddress(i: number) {
  // remove address from the list
  const remCtrl = (<any>this.bookingFrm).controls.delivery_sites;
  const control = <FormArray>remCtrl.controls['addresses'];
  control.removeAt(i);
}

countPickups() {
  const ptCtrl = (<any>this.bookingFrm).controls.pickup_sites;
  const control = <FormArray>ptCtrl.controls['addresses'];
  return control.length;
}

countDeliveries() {
  const ptCtrl = (<any>this.bookingFrm).controls.delivery_sites;
  const control = <FormArray>ptCtrl.controls['addresses'];
  return control.length;
}


getLocalStartAddressControl() {
  const ptCtrl = (<any>this.bookingFrm).controls.local_start_sites;
  const addCtrl = ptCtrl.controls.addresses;

  return addCtrl.controls;
}

getPickupAddressControl() {
  const ptCtrl = (<any>this.bookingFrm).controls.pickup_sites;
  const addCtrl = ptCtrl.controls.addresses;

  return addCtrl.controls;
}

getDeliveryAddressControl() {
  const ptCtrl = (<any>this.bookingFrm).controls.delivery_sites;
  const addCtrl = ptCtrl.controls.addresses;

  return addCtrl.controls;

}




getCustomerInputType() { 

  const pmCtrl = (<any>this.bookingFrm).controls.customer;
  const typeCtrl = pmCtrl.controls.type;

  return typeCtrl.value; 

}


getCustomerId () {
  const pmCtrl = (<any>this.bookingFrm).controls.customer;
  const existingCtrl = pmCtrl.controls.existing.controls.customerID;

  //return this.connote.customer_id;
  return existingCtrl.value;

}


setCustomerType(type: string) {
  // update customer input method type value
  const ctrl: FormControl = (<any>this.bookingFrm).controls["customer"].controls["type"];
  ctrl.setValue(type);

  const pmCtrl = (<any>this.bookingFrm).controls.customer;
    const existingCtrl = pmCtrl.controls.existing.controls.customerID;
    existingCtrl.setValue(0);
    const existingTplCtrl = pmCtrl.controls.existing.controls.tplConnoteId;
    existingTplCtrl.setValue(0);
    const existingTemplateCtrl = (<any>this.bookingFrm).controls.template_name;
    existingTemplateCtrl.setValue('');
    this.selectedCustomer = [];
}

setJobType(type: number) {
  // update job type value
  const ctrl: FormControl = (<any>this.bookingFrm).controls["job_type_id"];
  ctrl.setValue(type);
  this.jobType = type;
  this.setServiceType(0);

  if (type==this.BOOKING_TYPE.LOCAL) this.showLocalStartTab = true; else this.showLocalStartTab = false;

  if (type==this.BOOKING_TYPE.EMPTYRUN){

    const cCtrl = (<any>this.bookingFrm).controls.customer;
    const idCtrl = cCtrl.controls.existing.controls.customerID;
    const tplCtrl = cCtrl.controls.existing.controls.tplConnoteId;
    
    idCtrl.setValue(0);
    tplCtrl.setValue('');
    this.selectedCustomer = [];
  }

  if (type==this.BOOKING_TYPE.TOWHAUL) {
    this.showPackagingForm = false;
  }else{
    this.showPackagingForm = true;
  }

  if(type==this.BOOKING_TYPE.EMPTYRUN || type==this.BOOKING_TYPE.TOWHAUL || type==this.BOOKING_TYPE.TRAILERHIRE){
    this.setLocalType(1);
    this.localStartOpeningTimePast = false;

    this.setLocalType(2);
    this.pickupOpeningTimePast = false;
    this.deliveryOpeningTimePast = false;
  }
}

getJobType() { 

  const typeCtrl = (<any>this.bookingFrm).controls.job_type_id;
  
  return typeCtrl.value; 

}

getJobTypeLabel() {

  if (this.getJobType()== this.BOOKING_TYPE.LINEHAUL) return this.BOOKING_TYPE_LABEL.LINEHAUL;
  else if (this.getJobType()== this.BOOKING_TYPE.LOCAL) return this.BOOKING_TYPE_LABEL.LOCAL;
  else if (this.getJobType()== this.BOOKING_TYPE.EMPTYRUN) return this.BOOKING_TYPE_LABEL.EMPTYRUN;
  else if (this.getJobType()== this.BOOKING_TYPE.TOWHAUL) return this.BOOKING_TYPE_LABEL.TOWHAUL;
  else if (this.getJobType()== this.BOOKING_TYPE.TRAILERHIRE) return this.BOOKING_TYPE_LABEL.TRAILERHIRE;

}

setLocalType(type: number){
  let d: Date = new Date();

  for(var i=1 ;i<=4;i++)
  {
      var quarter_min = Math.ceil((d.getMinutes() / 15)) *15 +(i*15);
      var d2 = new Date(d.getTime() + (quarter_min - d.getMinutes()) *60000);
  }

  var hours = (d2.getHours()%24) -1;
  var minutes = d2.getMinutes();
  if (hours == -1) hours = 11;

  let date = {date:{year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()}}
  let op = {hour: hours , minute: minutes};
  let cls = {hour: hours , minute: minutes};

  if (type == this.LOCAL_TYPE.LOCAL_START){

    //reset form and add date and time to prevent validation errors
    //wont be d
    let alength = (<any>this.bookingFrm).controls.pickup_sites.controls['addresses'].length -1
    for (let i = 0; i <= alength; i++){
      if(i == 0){
        (<any>this.bookingFrm).controls.pickup_sites.reset();
        const pcontrol = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls[0].get('date');
        const pcontrol2 = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls[0].get('opening_time');
        const pcontrol3 = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls[0].get('closing_time');
        pcontrol.setValue(date);
        pcontrol2.setValue(op);
        pcontrol3.setValue(cls);

        (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls[0].get('activity_type_id').setValue(1);
        (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls[0].get('is_tba').setValue(false);
      } else this.removePickupAddress(1)
      
      
    }
    
    let dlength = (<any>this.bookingFrm).controls.delivery_sites.controls['addresses'].length -1
    for (let i = 0; i <= dlength; i++){
      if(i == 0){
        (<any>this.bookingFrm).controls.delivery_sites.reset();
        const dcontrol = (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.controls[0].get('date');
        const dcontrol2 = (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.controls[0].get('opening_time');
        const dcontrol3 = (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.controls[0].get('closing_time');
        dcontrol.setValue(date);
        dcontrol2.setValue(op);
        dcontrol3.setValue(cls);
        
        (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.controls[0].get('activity_type_id').setValue(2);
        (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.controls[0].get('is_tba').setValue(false);
      } else this.removeDeliveryAddress(1)
    }

  } else {
    //reset form and add date and time to prevent validation errors
    //wont be saved

    (<any>this.bookingFrm).controls.local_start_sites.reset();
    const control = (<any>this.bookingFrm).controls.local_start_sites.controls.addresses.controls[0].get('date');
    const control2 = (<any>this.bookingFrm).controls.local_start_sites.controls.addresses.controls[0].get('opening_time');
    const control3 = (<any>this.bookingFrm).controls.local_start_sites.controls.addresses.controls[0].get('closing_time');
    control.setValue(date);
    control2.setValue(op);
    control3.setValue(cls);

    (<any>this.bookingFrm).controls.local_start_sites.controls.addresses.controls[0].get('activity_type_id').setValue(5);
  }
  
  this.localType = type;
}

setLinehaulType(type: string) {
  // update job type value
  const ctrl: FormControl = (<any>this.bookingFrm).controls["linehaul_type_id"];

  ctrl.setValue(type);
  this.linehaulType = type;
  
  // Reset values stored in the form when LTL
  if(this.linehaulType == 2){
    this.bookingFrm.controls.service_type_id.setValue(0);
  }

}

getLinehaulType() { 

  const typeCtrl = (<any>this.bookingFrm).controls.linehaul_type_id;

  return typeCtrl.value; 

}

getLinehaulTypeLabel() {
  if (this.getJobType()== this.BOOKING_TYPE.LINEHAUL) {
    if (this.getLinehaulType()== this.LINEHAUL_TYPE.LTL) return this.LINEHAUL_TYPE_LABEL.LTL;
      else return this.LINEHAUL_TYPE_LABEL.FTL;
  }
  else return '';
}


/* setDGType(type: number) {
  // update job type value
  const ctrl: FormControl = (<any>this.bookingFrm).controls["dg_type_id"];

  ctrl.setValue(type);
}
 */


setDGType(type: number) {
  // update dg type value
  const dgCtrl = (<any>this.bookingFrm).controls.dgClass;
  const tCtrl = dgCtrl.controls.dg_type_id;
  tCtrl.setValue(type);
}
/* getDGType() { 

  const typeCtrl = (<any>this.bookingFrm).controls.dg_type_id;

  return typeCtrl.value; 

}
 */
getDGType() {
  // update dg type value
  const dgCtrl = (<any>this.bookingFrm).controls.dgClass;
  const tCtrl = dgCtrl.controls.dg_type_id;
  return tCtrl.value;
}


getServiceType() { 

  const typeCtrl = (<any>this.bookingFrm).controls.service_type_id;
  this.driversList = this.serviceTypeValueChange(typeCtrl.value);

  return typeCtrl.value; 
}

getServiceTypeLabel() { 

  var type = '';
  this.serviceTypes.forEach((item) => {
    if(item.id == this.getServiceType()) {
     type =  item.name;
    }
  });

  return type;
  
}

getServiceTypeAbbrv() { 

  var abbrv = '';
  this.serviceTypes.forEach((item) => {
    if(item.id == this.getServiceType()) {
     abbrv =  item.abbreviation;
    }
  });

  return abbrv;
  
}

setServiceType(value) { 

  const typeCtrl = (<any>this.bookingFrm).controls.service_type_id;

  this.setLinehaulType(this.LINEHAUL_TYPE.FTL)
  typeCtrl.setValue(value); 
}

onSelectDriver1() {
  
  const dCtrl = (<any>this.bookingFrm).controls.driver1_id;

  this.driver1Id = dCtrl.value;
}

onSelectDriver2() {
  const dCtrl = (<any>this.bookingFrm).controls.driver2_id;

  this.driver2Id = dCtrl.value;
}

async getCustomerRates(customerId) {
  const fuelLevyCtrl = (<any>this.bookingFrm).controls.fuel_levy;
  const serviceFeeCtrl = (<any>this.bookingFrm).controls.service_fee;
  
  console.log('selecting customer...',customerId);
  await this.bookingsService.getCustomerRates(customerId).subscribe(data => {
    console.log(data);
    if (data['customer_rates'].length > 0) {
      this.customerDefaultRates = data['customer_rates'][0];
      fuelLevyCtrl.setValue(this.customerDefaultRates['fuel_levy']);
      serviceFeeCtrl.setValue(this.customerDefaultRates['service_fee']);
      this.changeCostDefaultPricing();
    }
    else {
      this.customerDefaultRates = [];
      this.resetJobCostDefault();
      fuelLevyCtrl.setValue(0);
      serviceFeeCtrl.setValue(0);

      if(this.connote?.fuel_levy >  0){
        fuelLevyCtrl.setValue(this.connote.fuel_levy);
      }

      if(this.connote?.service_fee >  0){
        serviceFeeCtrl.setValue(this.connote.service_fee);
      }
      
    };
    this.computeTotalCost();
    
  });

}

async resetJobCostDefault(){
  await this.bookingsService.getAddBookingData().toPromise().then( data => {
    this.jobCostDefaults = data['job_cost_defaults'];
    this.costDefaults = this.jobCostDefaults;
  });
};

async changeCostDefaultPricing(){
  
  if(this.customerDefaultRates['tail_lift_per_pallet'] != null){this.costDefaults.tail_lift_per_pallet = this.customerDefaultRates['tail_lift_per_pallet'];};
  if(this.customerDefaultRates['hand_unload_per_pallet'] != null){this.costDefaults.hand_unload_per_pallet = this.customerDefaultRates['hand_unload_per_pallet'];};
  if(this.customerDefaultRates['extra_pickup_delivery'] != null){this.costDefaults.extra_pickup_delivery = this.customerDefaultRates['extra_pickup_delivery'];};
  if(this.customerDefaultRates['dg_packed'] != null){this.costDefaults.dg_packed = this.customerDefaultRates['dg_packed'];};
  if(this.customerDefaultRates['dg_bulk'] != null){this.costDefaults.dg_bulk = this.customerDefaultRates['dg_bulk'];};
  if(this.customerDefaultRates['bdbl_split_per_site'] != null){this.costDefaults.bdbl_split_per_site = this.customerDefaultRates['bdbl_split_per_site'];};
  if(this.customerDefaultRates['hr_waiting_time'] != null){this.costDefaults.hr_waiting_time = this.customerDefaultRates['hr_waiting_time'];};
  if(this.customerDefaultRates['semi_waiting_time'] != null){this.costDefaults.semi_waiting_time = this.customerDefaultRates['semi_waiting_time'];};
  if(this.customerDefaultRates['bdbl_waiting_time'] != null){this.costDefaults.bdbl_waiting_time = this.customerDefaultRates['bdbl_waiting_time'];};
  if(this.customerDefaultRates['hr_demurrage_per_hour'] != null){this.costDefaults.hr_demurrage_per_hour = this.customerDefaultRates['hr_demurrage_per_hour'];};
  if(this.customerDefaultRates['semi_demurrage_per_hour'] != null){this.costDefaults.semi_demurrage_per_hour = this.customerDefaultRates['semi_demurrage_per_hour'];};
  if(this.customerDefaultRates['bdbl_demurrage_per_hour'] != null){this.costDefaults.bdbl_demurrage_per_hour = this.customerDefaultRates['bdbl_demurrage_per_hour'];};
  if(this.customerDefaultRates['futile_per_pallet'] != null){this.costDefaults.futile_per_pallet = this.customerDefaultRates['futile_per_pallet'];};
  if(this.customerDefaultRates['extra_crew_per_pallet'] != null){this.costDefaults.extra_crew_per_pallet = this.customerDefaultRates['extra_crew_per_pallet'];};
  if(this.customerDefaultRates['residential_per_site'] != null){this.costDefaults.residential_per_site = this.customerDefaultRates['residential_per_site'];};
  if(this.customerDefaultRates['after_hours_per_site'] != null){this.costDefaults.after_hours_per_site = this.customerDefaultRates['after_hours_per_site'];};
  if(this.customerDefaultRates['hr_overnight_holding'] != null){this.costDefaults.hr_overnight_holding = this.customerDefaultRates['hr_overnight_holding'];};
  if(this.customerDefaultRates['semi_overnight_holding'] != null){this.costDefaults.semi_overnight_holding = this.customerDefaultRates['semi_overnight_holding'];};
  if(this.customerDefaultRates['bdbl_overnight_holding'] != null){this.costDefaults.bdbl_overnight_holding = this.customerDefaultRates['bdbl_overnight_holding'];};
  if(this.customerDefaultRates['pallet_max_width'] != null){this.costDefaults.pallet_max_width = this.customerDefaultRates['pallet_max_width'];};
  if(this.customerDefaultRates['pallet_max_length'] != null){this.costDefaults.pallet_max_length = this.customerDefaultRates['pallet_max_length'];};
  if(this.customerDefaultRates['pallet_max_height'] != null){this.costDefaults.pallet_max_height = this.customerDefaultRates['pallet_max_height'];};
  if(this.customerDefaultRates['pallet_max_weight'] != null){this.costDefaults.pallet_max_weight = this.customerDefaultRates['pallet_max_weight'];};
  if(this.customerDefaultRates['hr_default_load_rate'] != null){this.costDefaults.hr_default_load_rate = this.customerDefaultRates['hr_default_load_rate'];};
  if(this.customerDefaultRates['semi_default_load_rate'] != null){this.costDefaults.semi_default_load_rate = this.customerDefaultRates['semi_default_load_rate'];};
  if(this.customerDefaultRates['bdbl_default_load_rate'] != null){this.costDefaults.bdbl_default_load_rate = this.customerDefaultRates['bdbl_default_load_rate'];};
  if(this.customerDefaultRates['cubic_weight_param'] != null){this.costDefaults.cubic_weight_param = this.customerDefaultRates['cubic_weight_param'];};
  
  setTimeout(() => {},300);
};

getDriver1() { 

  const dCtrl = (<any>this.bookingFrm).controls.driver1_id;

  return dCtrl.value; 
}

getDriver2() { 

  const dCtrl = (<any>this.bookingFrm).controls.driver2_id;
  return dCtrl.value; 
}

getTruck() {
  const dCtrl = (<any>this.bookingFrm).controls.truck_id;

  return dCtrl.value; 
}


getTrailerA() {
  const dCtrl = (<any>this.bookingFrm).controls.trailerA_id;

  return dCtrl.value; 
}

getTrailerB() {
  const dCtrl = (<any>this.bookingFrm).controls.trailerB_id;

  return dCtrl.value; 
}


getTrailerC() {
  const dCtrl = (<any>this.bookingFrm).controls.trailerC_id;

  return dCtrl.value; 
}

getTrailerD() {
  const dCtrl = (<any>this.bookingFrm).controls.trailerD_id;
  return dCtrl.value; 
}


getTrailerE() {
  const dCtrl = (<any>this.bookingFrm).controls.trailerE_id;

  return dCtrl.value; 
}

getTrailerF() {
  const dCtrl = (<any>this.bookingFrm).controls.trailerF_id;

  return dCtrl.value; 
}


setDriver1(value) {
  const dCtrl = (<any>this.bookingFrm).controls.driver1_id;
  dCtrl.setValue(value);
}

setDriver2(value) {
  const dCtrl = (<any>this.bookingFrm).controls.driver2_id;
  dCtrl.setValue(value);
}


setTruck(value: number) {
  const dCtrl = (<any>this.bookingFrm).controls.truck_id;
  dCtrl.setValue(value);
}

setTrailerA(value: number) {
  const dCtrl = (<any>this.bookingFrm).controls.trailerA_id;
  dCtrl.setValue(value);
}

setTrailerB(value: number) {
  const dCtrl = (<any>this.bookingFrm).controls.trailerB_id;
  dCtrl.setValue(value);
}

setTrailerC(value: number) {
  const dCtrl = (<any>this.bookingFrm).controls.trailerC_id;
  dCtrl.setValue(value);
}

setTrailerD(value: number) {
  const dCtrl = (<any>this.bookingFrm).controls.trailerD_id;
  dCtrl.setValue(value);
}

setTrailerE(value: number) {
  const dCtrl = (<any>this.bookingFrm).controls.trailerE_id;
  dCtrl.setValue(value);
}

setTrailerF(value: number) {
  const dCtrl = (<any>this.bookingFrm).controls.trailerF_id;
  dCtrl.setValue(value);
}








isServiceTypeHidden(serviceType){
  var sv_abbrv = serviceType.abbreviation;
  const serviceTypeCtrl = (<any>this.bookingFrm).controls.service_type_id;
  if (this.getJobType() == this.BOOKING_TYPE.LOCAL && sv_abbrv != this.SERVICE_TYPE_ABBRV.UTE && sv_abbrv != this.SERVICE_TYPE_ABBRV.RIGID && sv_abbrv != this.SERVICE_TYPE_ABBRV.TWOTONES && sv_abbrv != this.SERVICE_TYPE_ABBRV.SEMIPM && sv_abbrv != this.SERVICE_TYPE_ABBRV.SEMI
      && sv_abbrv != this.SERVICE_TYPE_ABBRV.BDPM && sv_abbrv != this.SERVICE_TYPE_ABBRV.BDBL && sv_abbrv != this.SERVICE_TYPE_ABBRV.SIXTONES && sv_abbrv != this.SERVICE_TYPE_ABBRV.TWELVETONES && sv_abbrv != this.SERVICE_TYPE_ABBRV.BDPMA 
      && sv_abbrv != this.SERVICE_TYPE_ABBRV.BDPMB && sv_abbrv != this.SERVICE_TYPE_ABBRV.TENPALLETS && sv_abbrv != this.SERVICE_TYPE_ABBRV.TWOTONNE6P && sv_abbrv != this.SERVICE_TYPE_ABBRV.SIXTONNE10P && sv_abbrv != this.SERVICE_TYPE_ABBRV.EIGHTTTONE12P
      && sv_abbrv != this.SERVICE_TYPE_ABBRV.TWELVETONNE12P){
    return  true
  }
  //  --- Removed commented code to restrict service types in linehaul --- 
  else if(this.getJobType() == this.BOOKING_TYPE.LINEHAUL && sv_abbrv != this.SERVICE_TYPE_ABBRV.SEMI && sv_abbrv !=  this.SERVICE_TYPE_ABBRV.BDBL && sv_abbrv != this.SERVICE_TYPE_ABBRV.ROADTRAIN && sv_abbrv != this.SERVICE_TYPE_ABBRV.BDPMA 
  && sv_abbrv != this.SERVICE_TYPE_ABBRV.BDPMB && sv_abbrv != this.SERVICE_TYPE_ABBRV.TWELVETONES && sv_abbrv != this.SERVICE_TYPE_ABBRV.TWELVETONNE12P){ 
    return true
  }else if (this.getJobType() == this.BOOKING_TYPE.TRAILERHIRE && sv_abbrv != this.SERVICE_TYPE_ABBRV.ATRAILER && sv_abbrv != this.SERVICE_TYPE_ABBRV.BTRAILER  ){
    return true;
  } else if (this.getJobType() === this.BOOKING_TYPE.TOWHAUL && sv_abbrv != this.SERVICE_TYPE_ABBRV.SEMIPM && sv_abbrv != this.SERVICE_TYPE_ABBRV.BDPM){ 
    return true;
  }else if ( (this.getJobType() == this.BOOKING_TYPE.EMPTYRUN) && (sv_abbrv == this.SERVICE_TYPE_ABBRV.ATRAILER || sv_abbrv == this.SERVICE_TYPE_ABBRV.BTRAILER ) ){ 
    return true;
  } else return false;
}

toggleAddDrivers() {
  this.showAddDriverForm = !this.showAddDriverForm;
}

toggleAddEquipments() {
  this.showAddEquipmentForm = !this.showAddEquipmentForm;
}

toggleAddDG() {
  this.showDGForm = !this.showDGForm;

  if (this.showDGForm) {
    this.setDGType(this.DG_TYPE.PACKED);
  } else {
    const dgCtrl = (<any>this.bookingFrm).controls.is_dg;
    dgCtrl.setValue(true);
    this.setDGType(this.DG_TYPE.NONE);
  }
    


}

toggleAddPackaging() {
  this.showPackagingForm = !this.showPackagingForm;
}

togglePricingDetails() {
  this.showPricingDetailsForm = !this.showPricingDetailsForm;
}

isBillingChecked() {
  const ctrl = (<any>this.bookingFrm).controls.bill_to;

  var element = <HTMLInputElement> document.getElementById("billCheck");
  this.useCompanyBilling = element.checked;
  if (this.useCompanyBilling) {
    ctrl.controls.company.setValue('');
    ctrl.controls.address.setValue('');
    ctrl.controls.email.setValue('');
    ctrl.controls.contact_no.setValue('');
  }
}

fillCompanyName(control, name, types){
  let Ctrl;
  // if(this.getJobType() === this.BOOKING_TYPE.TOWHAUL) Ctrl = control['company_name']; else 
  Ctrl = control.controls['company_name'];
  const companyNameCtrl = Ctrl;

  if(types.find(x=>x == "establishment") != undefined) {
    let result = this.customers.find(x=> x.name.toLowerCase() == name.toLowerCase());
    if(result != undefined){
      companyNameCtrl.setValue(result.name);
    } else {
      let address_name = name.toLowerCase().split(' ')
      const keyword = this.customers.filter(x=>{ return (x.name.toLowerCase()).includes(address_name[0])})
      if(keyword.length !=0){
        if(keyword.length == 1){
          companyNameCtrl.setValue(name);
        } else {
          let result = keyword.find(x=>(x.name.toLowerCase()).includes(address_name[1]))
          if(result != undefined) companyNameCtrl.setValue(name); else companyNameCtrl.setValue('');
        }
      } else companyNameCtrl.setValue('');
    }
  } else companyNameCtrl.setValue('');
}

startSiteCallback(selectedData:any) {
  console.log(selectedData);
  const eCtrl = (<any>this.bookingFrm).controls.start_site.controls;
  //const eCtrl = <FormArray>pointCtrl.controls['addresses'].controls;

  const activityCtrl = eCtrl['activity_type_id'];
  const latCtrl = eCtrl["lat"];
  const longCtrl = eCtrl["long"];
  const streetNoCtrl = eCtrl["street_no"];
  const streetCtrl = eCtrl["street"];
  const suburbCtrl = eCtrl["suburb"];
  const stateCtrl = eCtrl["state"];
  const stateIdCtrl = eCtrl["state_id"];
  const postalCodeCtrl = eCtrl["postal_code"];
  const companyCtrl = eCtrl["company_name"];

  // Set activity site to 'start' if towhaul, else use empty run start
  // if (this.getJobType() === this.BOOKING_TYPE.TOWHAUL)  
  //   activityCtrl.setValue(5);  
  latCtrl.reset();
  longCtrl.reset();
  streetNoCtrl.reset();
  streetCtrl.reset();
  suburbCtrl.reset();
  stateCtrl.reset();
  stateIdCtrl.reset();
  postalCodeCtrl.reset(); 
  companyCtrl.reset();

  if (typeof selectedData === 'string' || selectedData instanceof String)
    this.pointdata = selectedData;
  else
    this.pointdata = JSON.stringify(selectedData);

  if (selectedData) {

    this.mapObj = JSON.parse(this.pointdata);
    this.mapObj = this.mapObj.data;
    this.mapLat = this.mapObj.geometry.location.lat;
    this.mapLng = this.mapObj.geometry.location.lng;
    if (this.getJobType() != this.BOOKING_TYPE.EMPTYRUN) this.fillCompanyName(eCtrl, this.mapObj.name, this.mapObj.types);
    
    latCtrl.setValue(this.mapLat);
    longCtrl.setValue(this.mapLng);

    var arr = [];
    
    arr[0] = this.mapLat;
    arr[1] = this.mapLng;
        
    
    //console.log(this.mapObj.address_components);
    for(let result of this.mapObj.address_components){

      // enable address form editing
      streetNoCtrl.enable();
      streetCtrl.enable();
      suburbCtrl.enable();
      postalCodeCtrl.enable();


      if (result.types == "street_number")
          streetNoCtrl.setValue(result.short_name);
      if (result.types == "route")
          streetCtrl.setValue(result.short_name);
      if ( result.types.includes("locality") ) 
          suburbCtrl.setValue(result.short_name);
      if ( result.types.includes("postal_code") ) 
          postalCodeCtrl.setValue(result.short_name);

      if ( result.types.includes("administrative_area_level_1") ) {
        let stateId = null;
        this.states.forEach((item) => {
            if (item.abbreviation === result.short_name) {
                stateId = item.id;
            }
        });
        stateIdCtrl.setValue(stateId); 
        stateCtrl.setValue(result.short_name);
      }
    }
    console.log(this.mapObj.address_components);
    
    //check if location is already in database and reload set open and close business hours
    this.checkBusinessHours(eCtrl);
  }

}


endSiteCallback(selectedData:any) {
  console.log(selectedData);
  const eCtrl = (<any>this.bookingFrm).controls.end_site.controls;

  const activityCtrl = eCtrl['activity_type_id'];
  const latCtrl = eCtrl["lat"];
  const longCtrl = eCtrl["long"];
  const streetNoCtrl = eCtrl["street_no"];
  const streetCtrl = eCtrl["street"];
  const suburbCtrl = eCtrl["suburb"];
  const stateCtrl = eCtrl["state"];
  const stateIdCtrl = eCtrl["state_id"];
  const postalCodeCtrl = eCtrl["postal_code"];
  const companyCtrl = eCtrl["company_name"];

  // Set activity to 'end' if towhaul, else use default empty run end
  // if (this.getJobType() === this.BOOKING_TYPE.TOWHAUL) 
  //   activityCtrl.setValue(6);

  latCtrl.reset();
    longCtrl.reset();
    streetNoCtrl.reset();
    streetCtrl.reset();
    suburbCtrl.reset();
    stateCtrl.reset();
    stateIdCtrl.reset();
    postalCodeCtrl.reset(); 
    companyCtrl.reset()

    if (typeof selectedData === 'string' || selectedData instanceof String)
      this.pointdata = selectedData;
    else
      this.pointdata = JSON.stringify(selectedData);

    if (selectedData) {

      this.mapObj = JSON.parse(this.pointdata);
      this.mapObj = this.mapObj.data;
      this.mapLat = this.mapObj.geometry.location.lat;
      this.mapLng = this.mapObj.geometry.location.lng;
      if (this.getJobType() != this.BOOKING_TYPE.EMPTYRUN) this.fillCompanyName(eCtrl, this.mapObj.name, this.mapObj.types);
      latCtrl.setValue(this.mapLat);
      longCtrl.setValue(this.mapLng);

      var arr = [];
      
      arr[0] = this.mapLat;
      arr[1] = this.mapLng;
        
      // enable address form editing
      streetNoCtrl.enable();
      streetCtrl.enable();
      suburbCtrl.enable();
      postalCodeCtrl.enable();
     
      for(let result of this.mapObj.address_components){
        if (result.types == "street_number")
            streetNoCtrl.setValue(result.short_name);
        if (result.types == "route")
            streetCtrl.setValue(result.short_name);
        if ( result.types.includes("locality") ) 
            suburbCtrl.setValue(result.short_name);
        if ( result.types.includes("postal_code") ) 
            postalCodeCtrl.setValue(result.short_name);

        if ( result.types.includes("administrative_area_level_1") ) {
          let stateId = null;
          this.states.forEach((item) => {
              if (item.abbreviation === result.short_name) {
                  stateId = item.id;
              }
          });
          stateIdCtrl.setValue(stateId); 
          stateCtrl.setValue(result.short_name);
        }
      }
  
      console.log(this.mapObj.address_components);

      //check if location is already in database and reload set open and close business hours
      this.checkBusinessHours(eCtrl);
    
    }
 
}


localStartAddressCallback(selectedData:any,i:number) {
  console.log(selectedData);
  const pCtrl = (<any>this.bookingFrm).controls.local_start_sites;
  const pickupCtrl = <FormArray>pCtrl.controls['addresses'].controls[i];

  const latCtrl = pickupCtrl.controls["lat"];
  const longCtrl = pickupCtrl.controls["long"];
  const streetNoCtrl = pickupCtrl.controls["street_no"];
  const streetCtrl = pickupCtrl.controls["street"];
  const suburbCtrl = pickupCtrl.controls["suburb"];
  const stateIdCtrl = pickupCtrl.controls["state_id"];
  const stateCtrl = pickupCtrl.controls["state"];
  const postalCodeCtrl = pickupCtrl.controls["postal_code"];
  const companyCtrl =  pickupCtrl.controls["company_name"];
  
  latCtrl.reset();
    longCtrl.reset();
    streetNoCtrl.reset();
    streetCtrl.reset();
    suburbCtrl.reset();
    stateIdCtrl.reset();
    stateCtrl.reset();
    postalCodeCtrl.reset(); 
    companyCtrl.reset();
  
    if (typeof selectedData === 'string' || selectedData instanceof String)
      this.pointdata = selectedData;
    else
      this.pointdata = JSON.stringify(selectedData);

    if (selectedData) {

      this.mapObj = JSON.parse(this.pointdata);
      this.mapObj = this.mapObj.data;
      this.mapLat = this.mapObj.geometry.location.lat;
      this.mapLng = this.mapObj.geometry.location.lng;
      this.fillCompanyName(pickupCtrl, this.mapObj.name, this.mapObj.types);
      latCtrl.setValue(this.mapLat);
      longCtrl.setValue(this.mapLng);

      var arr = [];
      
      arr[0] = this.mapLat;
      arr[1] = this.mapLng;
          
      this.positions[i] = arr;
     
      // enable address form editing
      streetNoCtrl.enable();
      streetCtrl.enable();
      suburbCtrl.enable();
      postalCodeCtrl.enable();
      
      //console.log(this.mapObj.address_components);
      for(let result of this.mapObj.address_components){
          if (result.types == "street_number")
              streetNoCtrl.setValue(result.short_name);
          if (result.types == "route")
              streetCtrl.setValue(result.short_name);
          if ( result.types.includes("locality") ) 
              suburbCtrl.setValue(result.short_name);
          if ( result.types.includes("postal_code") ) 
              postalCodeCtrl.setValue(result.short_name);
          if ( result.types.includes("administrative_area_level_1") ) {
            let stateId = null;
            this.states.forEach((item) => {
                if (item.abbreviation === result.short_name) {
                    stateId = item.id;
                }
            });
            stateIdCtrl.setValue(stateId); 
            stateCtrl.setValue(result.short_name);
          }
      }
      console.log(this.mapObj.address_components);
      
      //check if location is already in database and reload set open and close business hours
      this.checkBusinessHours(pickupCtrl.controls);
      
    }
 
}

pickupAddressCallback(selectedData:any,i:number) {
  console.log(selectedData);
  const pCtrl = (<any>this.bookingFrm).controls.pickup_sites;
  const pickupCtrl = <FormArray>pCtrl.controls['addresses'].controls[i];

  const latCtrl = pickupCtrl.controls["lat"];
  const longCtrl = pickupCtrl.controls["long"];
  const streetNoCtrl = pickupCtrl.controls["street_no"];
  const streetCtrl = pickupCtrl.controls["street"];
  const suburbCtrl = pickupCtrl.controls["suburb"];
  const stateCtrl = pickupCtrl.controls["state"];
  const stateIdCtrl = pickupCtrl.controls["state_id"];
  const postalCodeCtrl = pickupCtrl.controls["postal_code"];
  const companyCtrl =  pickupCtrl.controls["company_name"];

  latCtrl.reset();
    longCtrl.reset();
    streetNoCtrl.reset();
    streetCtrl.reset();
    suburbCtrl.reset();
    stateCtrl.reset();
    stateCtrl.reset();
    stateIdCtrl.reset();
    postalCodeCtrl.reset(); 
    companyCtrl.reset();

    if (typeof selectedData === 'string' || selectedData instanceof String)
      this.pointdata = selectedData;
    else
      this.pointdata = JSON.stringify(selectedData);

    if (selectedData) {

      this.mapObj = JSON.parse(this.pointdata);
      this.mapObj = this.mapObj.data;
      this.mapLat = this.mapObj.geometry.location.lat;
      this.mapLng = this.mapObj.geometry.location.lng;
      this.fillCompanyName(pickupCtrl, this.mapObj.name, this.mapObj.types);
      latCtrl.setValue(this.mapLat);
      longCtrl.setValue(this.mapLng);

      var arr = [];
      
      arr[0] = this.mapLat;
      arr[1] = this.mapLng;
          
      this.positions[i] = arr;

      // enable address form editing
      streetNoCtrl.enable();
      streetCtrl.enable();
      suburbCtrl.enable();
      postalCodeCtrl.enable();
     
      //console.log(this.mapObj.address_components);
      for(let result of this.mapObj.address_components){
          if (result.types == "street_number")
              streetNoCtrl.setValue(result.short_name);
          if (result.types == "route")
              streetCtrl.setValue(result.short_name);
          if ( result.types.includes("locality") ) 
              suburbCtrl.setValue(result.short_name);
          if ( result.types.includes("postal_code") ) 
              postalCodeCtrl.setValue(result.short_name);
          if ( result.types.includes("administrative_area_level_1") ) {
            let stateId = null;
            this.states.forEach((item) => {
                if (item.abbreviation === result.short_name) {
                    stateId = item.id;
                }
            });
            stateIdCtrl.setValue(stateId); 
            stateCtrl.setValue(result.short_name);
          }
      }
      console.log(this.mapObj.address_components);
      
      //company name

      //check if location is already in database and reload set open and close business hours
      this.checkBusinessHours(pickupCtrl.controls);
      
    }
 
}

deliveryAddressCallback(selectedData:any,i:number) {
  console.log(selectedData);
  const dCtrl = (<any>this.bookingFrm).controls.delivery_sites;
  const deliveryCtrl = <FormArray>dCtrl.controls['addresses'].controls[i];


  const latCtrl = deliveryCtrl.controls["lat"];
  const longCtrl = deliveryCtrl.controls["long"];
  const streetNoCtrl = deliveryCtrl.controls["street_no"];
  const streetCtrl = deliveryCtrl.controls["street"];
  const suburbCtrl = deliveryCtrl.controls["suburb"];
  const stateCtrl = deliveryCtrl.controls["state"];
  const stateIdCtrl = deliveryCtrl.controls["state_id"]
  const postalCodeCtrl = deliveryCtrl.controls["postal_code"];
  const companyCtrl =  deliveryCtrl.controls["company_name"];

  latCtrl.reset();
    longCtrl.reset();
    streetNoCtrl.reset();
    streetCtrl.reset();
    suburbCtrl.reset();
    stateCtrl.reset();
    stateCtrl.reset();
    stateIdCtrl.reset();
    postalCodeCtrl.reset(); 
    companyCtrl.reset()

    if (typeof selectedData === 'string' || selectedData instanceof String)
      this.pointdata = selectedData;
    else
      this.pointdata = JSON.stringify(selectedData);

    if (selectedData) {

      this.mapObj = JSON.parse(this.pointdata);
      this.mapObj = this.mapObj.data;
      this.mapLat = this.mapObj.geometry.location.lat;
      this.mapLng = this.mapObj.geometry.location.lng;
      this.fillCompanyName(deliveryCtrl, this.mapObj.name, this.mapObj.types);
      latCtrl.setValue(this.mapLat);
      longCtrl.setValue(this.mapLng);

      var arr = [];
      
      arr[0] = this.mapLat;
      arr[1] = this.mapLng;
          
      this.positions[i] = arr;
     
      // enable address form editing
      streetNoCtrl.enable();
      streetCtrl.enable();
      suburbCtrl.enable();
      postalCodeCtrl.enable();
      
      //console.log(this.mapObj.address_components);
      for(let result of this.mapObj.address_components){
          if (result.types == "street_number")
              streetNoCtrl.setValue(result.short_name);
          if (result.types == "route")
              streetCtrl.setValue(result.short_name);
          if ( result.types.includes("locality") ) 
              suburbCtrl.setValue(result.short_name);
          if ( result.types.includes("postal_code") ) 
              postalCodeCtrl.setValue(result.short_name);
          if ( result.types.includes("administrative_area_level_1") ) {
            let stateId = null;
            this.states.forEach((item) => {
                if (item.abbreviation === result.short_name) {
                    stateId = item.id;
                }
            });
            stateIdCtrl.setValue(stateId); 
            stateCtrl.setValue(result.short_name);
          }
      }
      console.log(this.mapObj.address_components);

      //check if location is already in database and reload set open and close business hours
      this.checkBusinessHours(deliveryCtrl.controls);
       
    }
}

onSelectServiceType (event: any) {
  //update the ui
  console.log('changed st');
  console.log(event.target.value);

}

showAddBookingPage() {
  this.bookingFrm.reset();
  this.initBookingFrm();
  this.router.navigate(['bookings/add']);
  this.submitted = false;

}

showConnoteListPage() {
  this.router.navigate(['bookings/connotesv2']);
}

showConnotesPage() {
  this.router.navigate(['bookings/connotes']);
}


isDispatchable() {
  const ctrl = (<any>this.bookingFrm).controls;
  var dispatchable: boolean = false;
  var jobType = this.getJobType();
  var service = this.bookingFrm.controls.service_type_id.value;

  //get abbreviation value of the  service type to use in conditions
  var service_abbrv = '';
  service_abbrv = this.getServiceTypeAbbrv();
  
  if (jobType < 5) {
    if ((jobType == 2 && ctrl.linehaul_type_id.value == '1') || jobType == 1 || jobType == 3 || jobType == 4){
      if((service_abbrv == this.SERVICE_TYPE_ABBRV.UTE || service_abbrv == this.SERVICE_TYPE_ABBRV.RIGID) || service_abbrv == this.SERVICE_TYPE_ABBRV.TWOTONES || service_abbrv == this.SERVICE_TYPE_ABBRV.SEMIPM || service_abbrv == this.SERVICE_TYPE_ABBRV.BDPM || service_abbrv == this.SERVICE_TYPE_ABBRV.SIXTONES || service_abbrv == this.SERVICE_TYPE_ABBRV.TWELVETONES || service_abbrv == this.SERVICE_TYPE_ABBRV.TENPALLETS
          || service_abbrv == this.SERVICE_TYPE_ABBRV.TWOTONNE6P || service_abbrv == this.SERVICE_TYPE_ABBRV.SIXTONNE10P || service_abbrv == this.SERVICE_TYPE_ABBRV.EIGHTTTONE12P || service_abbrv == this.SERVICE_TYPE_ABBRV.TWELVETONNE12P){
        if (ctrl.driver1_id.value && ctrl.truck_id.value) dispatchable = true;
      } else if(service_abbrv == this.SERVICE_TYPE_ABBRV.SEMI){
        if (ctrl.driver1_id.value && ctrl.truck_id.value != 0){
          if (ctrl.trailerA_id.value !=0 && ctrl.trailerB_id.value == 0){
            dispatchable = true;
          } else if (ctrl.trailerA_id.value == 0 && ctrl.trailerB_id.value !=0){ 
            dispatchable = true;
          } else dispatchable = false;
          
          if (ctrl.trailerA_id.value != 0 && ctrl.trailerB_id.value != 0) dispatchable = false;
        }
      } else if(service_abbrv == this.SERVICE_TYPE_ABBRV.BDBL){
        if (ctrl.driver1_id.value && ctrl.truck_id.value && ctrl.trailerA_id.value && ctrl.trailerB_id.value) dispatchable = true;
      } else if(service_abbrv == this.SERVICE_TYPE_ABBRV.BDPMA || service_abbrv == this.SERVICE_TYPE_ABBRV.BDPMB){
        if (ctrl.driver1_id.value && ctrl.truck_id.value && (ctrl.trailerA_id.value || ctrl.trailerB_id.value)) dispatchable = true;
      } else if(service_abbrv == this.SERVICE_TYPE_ABBRV.ROADTRAIN){
        if (ctrl.driver1_id.value && ctrl.truck_id.value) dispatchable = true;
      } else if(service_abbrv == this.SERVICE_TYPE_ABBRV.ATRAILER || service_abbrv == this.SERVICE_TYPE_ABBRV.BTRAILER){
        if (ctrl.driver1_id.value && (ctrl.trailerA_id.value || ctrl.trailerB_id.value)) dispatchable = true;
      }
    }
  }
    
  return dispatchable;

}

processForm() {
  const ctrl = (<any>this.bookingFrm).controls;
  if(this.isBookingFrmValid()){
    if (this.getJobType() != 3) {
      ctrl.start_site.reset();
      ctrl.end_site.reset();
    }
  
    if (this.getJobType() != 5) {
      ctrl.trailer_hire_start.reset();
      ctrl.trailer_hire_end.reset();
  
    }
  
    if (this.getJobType() > 2 ) {
      ctrl.is_dg.setValue(false);
      ctrl.dgClass.controls.dg_type_id.setValue(this.DG_TYPE.NONE);
      ctrl.packagings.reset();
      ctrl.local_start_sites.reset();
  
      // if (this.getJobType() != 4) {
      //   ctrl.pickup_sites.reset();
      //   ctrl.delivery_sites.reset();
      // }
    }

    if(this.getJobType() == 1){
      if(this.localType == 1){
        ctrl.pickup_sites.reset();
        ctrl.delivery_sites.reset();
      } else if (this.localType == 2){
        ctrl.local_start_sites.reset();
      }
    }
    this.computeTotalCost();
    this.recomputeForm();
    this.save(this.bookingFrm.getRawValue());
  }
}


cleardispatch(){
  const ctrl = (<any>this.bookingFrm).controls;
  if (this.getJobType() != 3) {
    ctrl.start_site.reset();
    ctrl.end_site.reset();
  }

  if (this.getJobType() != 5) {
    ctrl.trailer_hire_start.reset();
    ctrl.trailer_hire_end.reset();

  }

  if (this.getJobType() > 2 ) {
    ctrl.is_dg.setValue(false);
    ctrl.dgClass.controls.dg_type_id.setValue(this.DG_TYPE.NONE);
    ctrl.packagings.reset();
    ctrl.local_start_sites.reset();

    // if (this.getJobType() != 4) {
    //   ctrl.pickup_sites.reset();
    //   ctrl.delivery_sites.reset();
    // }
  }
}

processDispatchForm() {
  const ctrl = (<any>this.bookingFrm).controls;
  let startState = [];

  this.has_tba = this.checkDeliverTBA();
  if(this.has_tba){
    this.bookingFrm.controls.has_tba.setValue(1);
    startState = ctrl.pickup_sites.controls['addresses'].value;
    this.sorted_routes = this.run_routes.filter(x=>x['start_state_id'] == startState[0].state_id);
    this.modal.open(this.modalDispatchRoute, { container: '.app', size: 'md', backdrop: 'static'});
  }else{
    this.bookingFrm.controls.has_tba.setValue(0);
    this.cleardispatch();
    this.recomputeForm();
    this.save(this.bookingFrm.getRawValue(), true);
  }
    
}


showTailgate() {

  var st = this.getServiceTypeAbbrv();
  
  if ( st == this.SERVICE_TYPE_ABBRV.SEMIPM || st == this.SERVICE_TYPE_ABBRV.SEMI || st == this.SERVICE_TYPE_ABBRV.BDPM || st == this.SERVICE_TYPE_ABBRV.BDBL || 
    st == this.SERVICE_TYPE_ABBRV.ROADTRAIN || st == this.SERVICE_TYPE_ABBRV.BDPMA || st == this.SERVICE_TYPE_ABBRV.BDPMB)
  return true;
  else return false;
}

showTrailerSplit() {

  var st = this.getServiceTypeAbbrv();
  if ( st == this.SERVICE_TYPE_ABBRV.BDBL || st == this.SERVICE_TYPE_ABBRV.ROADTRAIN ) return true;
  else return false;
}

onDGSelectChange(selectedId) {
  const dgCtrl = (<any>this.bookingFrm).controls.is_dg;
  dgCtrl.setValue(true);
  //console.log(pptCtrl.value);
} // end onDGCheckChange


onSubsidiaryChange(event) {
  const formArray: FormArray = this.bookingFrm.get('dgClass.subsidiaries') as FormArray;

  /* Selected */
  if (event.target.checked) {
      // Add a new control in the arrayForm
      formArray.push(new FormControl(event.target.value));
  }
  /* unselected */
  else {
      // find the unselected element
      let i: number = 0;

      formArray.controls.forEach((ctrl: FormControl) => {
          if (ctrl.value == event.target.value) {
              // Remove the unselected element from the arrayForm
              formArray.removeAt(i);
              return;
          }

          i++;
      });
  }

  const pptCtrl = (<any>this.bookingFrm).controls.dgClass;
} // end onDGCheckChange

checkSubsidiaryStatus(int: number) {
  const sCtrl = (<any>this.bookingFrm).controls.dgClass.controls.subsidiaries;
  
  if (sCtrl.value.includes(int.toString() ) )
      return true;
  else return false;

}

isDGMainClass(int: number) {
  const dgCtrl = (<any>this.bookingFrm).controls.dgClass.controls.dg_class_id;
  if (dgCtrl.value == int.toString() )          
      return true;
  else return false;

}

getSubsidiaries() {
  const sCtrl = (<any>this.bookingFrm).controls.dgClass.controls.subsidiaries;
  var shortStr: string = "";
  var longStr: string = "";
  var count = 0;
  this.dgLicenses.forEach(function (e) {
      if (sCtrl.value.includes(e.id.toString())) {
          count = count + 1;
          if (count > 1) {
              shortStr = shortStr + "/";
              longStr = longStr + "/"
          }
          shortStr = shortStr + e.name.replace("Class",'');
          longStr = longStr + e.name + "-" + e.description;
      }

  });
  return shortStr;


}
//clear checked subsidiaries
clearSubsidiaries() {
  const formArray: FormArray = this.bookingFrm.get('dgClass.subsidiaries') as FormArray;
  while (formArray.length !== 0) {
      formArray.removeAt(0)
  }
  console.log('subsidiaries cleared.')
}

hasSubsidiaryPick() {
  const pCtrl = (<any>this.bookingFrm).controls.dgClass.controls.subsidiaries;

  if (pCtrl.value.length > 0)
      return true;
  else return false;
}

hasDGPick() {
  const DGCtrl = (<any>this.bookingFrm).controls.dgClass;
  const classesCtrl = DGCtrl.controls.dg_class_id;
  const typeCtrl = DGCtrl.controls.dg_type_id;

  if (classesCtrl.value != '' && typeCtrl.value != null && this.showDGForm)
      return true;
  else return false;
}


pluralizePackagingType(type: string) {
  switch (type) {
    case 'box':{
      return 'boxes';
      break;
    }
    case 'cage': {
      return 'cages';
      break;
    }
    default: {
      return type;
    }
  }
}

 /* save(model: Booking, isDispatch: boolean = false) {
   console.log(model);
} */

getJobFile(event, type){
  (type == 10) ? console.log("DG File ", event) : console.log("Doc File ", event);
  let allowedExtension = ['pdf','png','jpg','gif'];

  if(event == null){
    if(type == 10) this.dg_file = event;
    else if(type == 11) this.doc_file = event;
  }
  else{
    let selectedFilename = event.file.name.split('.');
    let selectedFileExtension = selectedFilename[selectedFilename.length - 1].toLowerCase();
    console.log('selected file: ',selectedFilename);

    if( allowedExtension.includes(selectedFileExtension) ){
      let file: ImageResult;
      file = event;
      if(type == 10) this.dg_file = file;
      else if(type == 11) this.doc_file = file;
    }
    else{
      this.toastr.error('','Error: Extension Not Allowed', {
        timeOut: 5000,
        positionClass: 'toast-top-full-width',
        progressBar: true,
      });
    }
  }
}

uploadFile(file, type, connote_id){
  let folder = this.doc_types.filter(x => {return x.id == type})[0].folder;

  this.fileService.uploadRawFileWithRename(folder, file, file.file.name)
    .subscribe(result => {
      let job_file = {
        filename:                   result['data'],
        connote_id:                 connote_id,
        user_id:                    this.user.id,
        connote_document_type_id:   type,
        description:                '',
      };

      if(result['data']){
        this.bookingsService.createAdminUpload(job_file).subscribe(jobFile => {
        }, error => {
          this.toastr.error(this.doc_types.filter(x => {return x.id == type})[0].label, "There was a problem with uploading the selected file", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        });
      }else{
        this.toastr.error(this.doc_types.filter(x => {return x.id == type})[0].label, "There was a problem with uploading the selected file", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
      }
    });
}

  save(model: Booking, isDispatch: boolean = false) {
    this.hasDGPick()? model.is_dg = true: model.is_dg = false;
      this.loadingIndicator = true;
      const ctrl = (<any>this.bookingFrm).controls;
      
      if(!model.is_dg){ //null dg values if is_dg is true
        model.dgClass.dg_class_id = "";
        model.dgClass.dg_type_id = null;
      }
      
      //check if there is run_route_id selected
      if(this.route_id !==null && this.isset(this.route_id)){
        model.run_route_id= this.route_id;
      }

      console.log("MODEL 1", model);
      
      this.bookingsService.saveBooking(model).toPromise().then(async res => {
        var error = res['error'];
        var connoteId = res['connoteId'];
        
        if (error == false) {
            console.log('book and dispatch: ', isDispatch);

            if(this.doc_file != null) this.uploadFile(this.doc_file, 11, connoteId);
            if(model.dgClass.dg_class_id != '' && this.dg_file != null) this.uploadFile(this.dg_file, 10, connoteId);

            if (model.job_type_id != 3){
              this.bookingsService.createPackagingLabel(connoteId).subscribe(res => {
                if (model.job_type_id == 2 || model.job_type_id == 4 || (model.job_type_id == 1 && this.localType == 2)) {
                  console.log('Creating connote file & sending mail...');
                  
                  this.bookingsService.createConnoteFile(connoteId).subscribe(res => {
                    this.bookingsService.sendBookingMail(connoteId).subscribe(res => {});
                  });
                } 
              });
            };
            
            if (isDispatch) {
              this.cleardispatch(); //ensure correct values are saved
              await this.bookingsService.dispatch(connoteId, this.has_tba, this.route_id).toPromise().then(res2 => {
                if (res2['dispatch']['error'] == false)
                  this.dispatched = true; 
              });
            } 
            
            
              
        }  // end if there are no errors in saving new booking record

        setTimeout(() => { 
          if (error==false) {
            this.loadingIndicator = false;
            this.submitted = true;

            this.toastr.success("Your booking has been saved.", "Success!", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          }
          else {
            console.log("Failed Booking Here: ", res);
            this.loadingIndicator = false;
            this.toastr.error("Please try again.", "A problem was encountered while processing your booking.", {
              timeOut: 5000,
              positionClass: 'toast-top-full-width',
              progressBar: true
            });
          }
          
        }, 1500);
      });  
  }

 update(model: Booking) {
  console.log(model);
  model['local_type'] = this.localType;
  this.loadingIndicator = true;
  
    this.bookingsService.updateBooking(model).subscribe(res => {
      var error = res['error'];
      var connoteId = res['id'];
      
      setTimeout(() => { 
        this.loadingIndicator = false; 
        if (error==false) {
          if(this.doc_file != null) this.uploadFile(this.doc_file, 11, connoteId);
          if(model.dgClass.dg_class_id != '' && this.dg_file != null) this.uploadFile(this.dg_file, 10, connoteId);

          if (model.job_type_id == 2) {
            this.bookingsService.updateConnoteFile(connoteId).subscribe(res => {});
          }
          
          if (model.job_type_id != 3){
            this.bookingsService.createPackagingLabel(connoteId).subscribe(res => {});
          }

          this.toastr.success("", "Booking update saved successfully!", {
            timeOut: 3000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }
        else {
          console.log(res);
          this.toastr.error("Please try again.", "A problem was encountered while processing your booking.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }
        
      }, 1500);

      this.router.navigate(['/bookings/connotesv2']);
    });  
}

processEditForm() {
  console.log(this.bookingFrm.controls);
  const ctrl = (<any>this.bookingFrm).controls;

  if (this.getJobType() != 3) {
    ctrl.start_site.reset();
    ctrl.end_site.reset();
  }

  if (this.getJobType() != 5) {
    ctrl.trailer_hire_start.reset();
    ctrl.trailer_hire_end.reset();

  }

  if (this.getJobType() > 2 ) {
    ctrl.is_dg.setValue(false);
    ctrl.dgClass.controls.dg_type_id.setValue(this.DG_TYPE.NONE);
    ctrl.packagings.reset();
    ctrl.local_start_sites.reset();

    // if (this.getJobType() != 4) {
    //   ctrl.pickup_sites.reset();
    //   ctrl.delivery_sites.reset();
    // }

  }

  this.computeTotalCost();
  this.recomputeForm();
  this.update(this.bookingFrm.getRawValue());
}

processRebookForm() {

}

isCustomerFormValid() {
  const jobTypeId = (<any>this.bookingFrm).controls.job_type_id.value;
  const custCtrl = (<any>this.bookingFrm).controls.customer.controls;
  
  if (jobTypeId != '3') {
    if (custCtrl['type'].value == 'New') {
      if (!custCtrl['new'].controls['companyName'].value) return false;

    } else {
      if (!custCtrl['existing'].controls['customerID'].value || custCtrl['existing'].controls['customerID'].value == '0' || this.selectedCustomer.length == 0 ) return false;
    }    
  }

  return true;
}

isServiceTypeValid() {
  const jobTypeId = (<any>this.bookingFrm).controls.job_type_id.value;

  if (jobTypeId != '1' && (jobTypeId != '2' || (jobTypeId == '2' && this.linehaulType == '1' )))
      if (!this.getServiceType()) return false;
      else return true;
  else return true;
    
}

isTemplateNameValid : boolean = true;
isPackagingEntriesValid: boolean = true;

invalidPickupTime = [];
invalidDeliveryTime = [];

isPickupDeliveryMatch: boolean = true;
pickupPrecedesDelivery: boolean =  false; // Flag to track if at least one pickup precedes a delivery
isBookingFrmValid() {
  const jobTypeId = (<any>this.bookingFrm).controls.job_type_id.value;
  const custCtrl = (<any>this.bookingFrm).controls.customer.controls;
  const pkCtrl = (<any>this.bookingFrm).controls.packagings.controls;
  const lsCtrl = (<any>this.bookingFrm).controls.local_start_sites.controls.addresses.controls;
  const psCtrl = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls;
  const dsCtrl = (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.controls;
  const erStart = (<any>this.bookingFrm).controls.start_site.controls;
  const erEnd = (<any>this.bookingFrm).controls.end_site.controls;
  const thStart = (<any>this.bookingFrm).controls.trailer_hire_start.value;
  const thEnd = (<any>this.bookingFrm).controls.trailer_hire_end.value;

  var isValid:boolean = true;
  this.isIncompleteAddress = false;
  this.isTemplateNameValid = true;
  this.isPackagingEntriesValid = true;
  
    if (jobTypeId != '3') {
      if (custCtrl['type'].value == 'New') {
        if (!custCtrl['new'].controls['companyName'].value) isValid = false;

      } else {
        if (!custCtrl['existing'].controls['customerID'].value || custCtrl['existing'].controls['customerID'] == '0' || this.selectedCustomer.length == 0 ) isValid = false;
      }    
    }

    pkCtrl.forEach((item, index) => {
      if (item.controls['quantity'].value || item.controls['length'].value || item.controls['width'].value 
            || item.controls['height'].value || item.controls['weight'].value) {
         if (!item.controls['quantity'].value || !item.controls['length'].value || !item.controls['width'].value 
         || !item.controls['height'].value || !item.controls['weight'].value 
         || item.controls['height'].errors || item.controls['weight'].errors || item.controls['length'].errors || item.controls['width'].errors){
           isValid = false; 
           this.isPackagingEntriesValid = false; 
         }
        }
    });

    if (jobTypeId == '3') {
      let startYear = 0, startMonth = 0, startDay = 0, startDateObj, startDate;
      let endYear = 0, endMonth = 0, endDay = 0, endDateObj, endDate;
      
      //sets the closing time equal to opening time as new requirement in issue #686
      if(erStart['opening_time'].value){
        erStart['closing_time'].setValue(erStart['opening_time'].value);
      };
      if(erEnd['opening_time'].value){
        erEnd['closing_time'].setValue(erEnd['opening_time'].value);
      };      
      
      // Check location for Empty Run Start
      if (erStart['street_no'].value || erStart['street'].value || erStart['suburb'].value || erStart['state'].value || erStart['postal_code'].value){
        if (!erStart['street'].value || !erStart['suburb'].value || !erStart['state'].value || !erStart['postal_code'].value) {
          isValid = false; this.isIncompleteAddress = true;
        }
        else {this.hasStartSite = true; }  
      }else{ isValid = false; this.hasStartSite = false; };

      // Check location for Empty Run End 
      if (erEnd['street_no'].value || erEnd['street'].value || erEnd['suburb'].value || erEnd['state'].value || erEnd['postal_code'].value){
        if (!erEnd['street'].value || !erEnd['suburb'].value || !erEnd['state'].value || !erEnd['postal_code'].value) {
          isValid = false; this.isIncompleteAddress = true;
        }
        else{ this.hasEndSite = true; }  
      }else{ isValid = false; this.hasEndSite = false; }
     

      // Check null Empty Run or Towhaul Stat/End Dates
      if(erStart['date'].value == null){
        this.startDateNull = true;
        isValid = false;
      }else this.startDateNull = false;

      if(erEnd['date'].value == null){
        this.endDateNull = true;
        isValid = false;
      }else this.endDateNull = false;

      startYear = erStart['date'].value.date.year;
      startMonth = erStart['date'].value.date.month;
      startDay = erStart['date'].value.date.day;

      endYear = erEnd['date'].value.date.year;
      endMonth = erEnd['date'].value.date.month;
      endDay = erEnd['date'].value.date.day;

      startDateObj = new Date(startYear+'-'+startMonth+'-'+startDay);
      if(startDateObj != 'Invalid Date'){
        startDate = this.datePipe.transform(startDateObj, 'dd-MMM-yyyy');
      }

      endDateObj = new Date(endYear+'-'+endMonth+'-'+endDay);
      if(endDateObj != 'Invalid Date'){
        endDate = this.datePipe.transform(endDateObj, 'dd-MMM-yyyy');
      }

      const startTime = erStart['opening_time'].value;
      const startDateTime = new Date(
        startYear,
        startMonth,
        startDay,
        startTime.hour,
        startTime.minute
      );

      const endTime = erEnd['closing_time'].value;
      const endDateTime = new Date(
        endYear,
        endMonth,
        endDay,
        endTime.hour,
        endTime.minute
      );
      
      // Check Start Date and Time should be ahead of End Date and Time
      if(startDateTime.getTime() < endDateTime.getTime()){
        this.start_endDateInvalid = false;
      }else {
        this.start_endDateInvalid = true;
        isValid = false;
      }
    } else{ 
      this.hasEndSite = true; 
      this.pickupOpeningTimePast = false;
      this.deliveryOpeningTimePast = false;
    }

    if (jobTypeId == '5') {
      let startYear = 0, startMonth = 0, startDay = 0, startDateObj, startDate;
      let endYear = 0, endMonth = 0, endDay = 0, endDateObj, endDate;


      if (!thStart|| !thEnd) isValid = false;
      this.hasStartSite = true;

      // Check null Trailer Hire Dates
      if(thStart == null){
        this.trailerHireStartDateNull = true;
        isValid = false;
      }else this.trailerHireStartDateNull = false;

      if(thEnd == null){
        this.trailerHireEndDateNull = true;
        isValid = false;
      }else this.trailerHireEndDateNull = false;

      startYear = thStart.date.year;
      startMonth = thStart.date.month;
      startDay = thStart.date.day ;

      endYear = thEnd.date.year;
      endMonth = thEnd.date.month;
      endDay = thEnd.date.day;

      startDateObj = new Date(startYear+'-'+startMonth+'-'+startDay);
      if(startDateObj != 'Invalid Date'){
        startDate = this.datePipe.transform(startDateObj, 'dd-MMM-yyyy');
      }

      endDateObj = new Date(endYear+'-'+endMonth+'-'+endDay);
      if(endDateObj != 'Invalid Date'){
        endDate = this.datePipe.transform(endDateObj, 'dd-MMM-yyyy');
      }
      
      let s_Date = Date.parse(startDate);
      let e_Date = Date.parse(endDate);

      // Check Start Date is ahead of End Date
      if(s_Date > e_Date){
        this.trailerHireDateInvalid = true;
        isValid = false;
      }else this.trailerHireDateInvalid = false;
    }else{
      this.pickupOpeningTimePast = false;
      this.deliveryOpeningTimePast = false;
    }

    if (jobTypeId < 3 || jobTypeId == '4') {
      
      this.trailerHireDateInvalid = false;
      this.start_endDateInvalid = false;

      if (jobTypeId == '1') {
        this.pickupOpeningTimePast = false;
        this.deliveryOpeningTimePast = false;

        //console.log("VALID?", <any>this.bookingFrm);

        let localStartOpeningTime = [], localStartNullCount1 = 0; 
        let localStartDate = [], localStartDateCount = 0;

        if(this.localType == 1){
            lsCtrl.forEach((item) => {

              //sets the closing time equal to opening time as new requirement in issue #686
              item.get('closing_time').setValue(item.get('opening_time').value);

              if (item.controls['street_no'].value || item.controls['street'].value || item.controls['suburb'].value || 
                  item.controls['state'].value || item.controls['postal_code'].value) {
                    if (!item.controls['street'].value || !item.controls['suburb'].value || !item.controls['state'].value || !item.controls['postal_code'].value) {
                      isValid = false; this.isIncompleteAddress = true;
                    }else this.hasStartSite = true;
              } else {
                isValid = false;
                this.hasStartSite = false;
              }
    
              localStartOpeningTime.push(item.get('opening_time').value);
              localStartDate.push(item.get('date').value?.date);
    
              // Check null Opening Time of Local Start
              localStartNullCount1 = localStartOpeningTime.filter(x => x == null).length;
              if(localStartNullCount1 > 0 ){
                this.localStartOpenTimeNull = true;
                isValid = false;
              }else this.localStartOpenTimeNull = false;

              // Check null Date of Local Start
              localStartDateCount =  localStartDate.filter(x => x == undefined).length;
              if(localStartDateCount > 0){
                this.localStartDateNull =  true;
                isValid = false;
              }else this.localStartDateNull = false;
    
              if(localStartNullCount1 < 1 && !this.localStartDateNull){
                if(!this.editId){
                  for(let i=0; i < localStartOpeningTime.length; i++){
                    let openingTime = new Date();
                    
                    // Check Local Start Closing Time goes beyond given date
                    openingTime?.setHours(localStartOpeningTime[i]?.hour, localStartOpeningTime[i]?.minute, 0, 0);
      
                    let currTime = new Date();
                    this.localStartOpeningTimePast = false;
                    // Check set Date against current Date
                    if(localStartDate[i].year == currTime.getFullYear()){
                      if(localStartDate[i].month == currTime.getMonth()+1){
                        if(localStartDate[i].day == currTime.getDate()){
      
                          // Check past Opening Time of Local Start
                          if(localStartOpeningTime[i].hour < currTime.getHours()){
                            this.localStartOpeningTimePast = true;
                            isValid = false;
                          }else if(localStartOpeningTime[i].hour == currTime.getHours()){
                            if(localStartOpeningTime[i].minute < currTime.getMinutes()){
                              this.localStartOpeningTimePast = true;
                              isValid = false;
                            }
                          }
                          
                        }
                      }
                    }
                  }
                } else {
                  this.localStartOpeningTimePast = false;

                  for(let i=0; i < localStartOpeningTime.length; i++){
                    let openingTime = new Date(), closingTime = new Date();

                    // Check Local Start Closing Time goes beyond given date
                    openingTime?.setHours(localStartOpeningTime[i]?.hour, localStartOpeningTime[i]?.minute, 0, 0);
                  }
                }
              }
            });
        }else{ 
          this.hasDeliveryEndSite = false; 
          this.pickupPrecedesDelivery = true;
          this.isPickupDeliveryMatch = false;
        }
        
      }

      if(jobTypeId == '2' || this.localType == 2 || jobTypeId == '4' ){
        this.localStartOpeningTimePast = false;
        let pickupOpeningTime = [], pickupNullCount1 = 0;
          let deliveryOpeningTime = [], deliveryNullCount1 = 0;
          let pickupDate = [], deliveryDate = [], pickupDateCount = 0, deliveryDateCount = 0;
          psCtrl.forEach((item) => {
            //sets the closing time equal to opening time as new requirement in issue #686
            item.get('closing_time').setValue(item.get('opening_time').value);

            if (item.controls['street_no'].value || item.controls['street'].value || item.controls['suburb'].value || item.controls['state'].value || item.controls['postal_code'].value) {
                if (!item.controls['street'].value || !item.controls['suburb'].value || !item.controls['state'].value || !item.controls['postal_code'].value) {
                    isValid = false; this.isIncompleteAddress = true;
                }else this.hasStartSite = true;
            }else{ isValid = false; this.hasStartSite = false; }
    
            pickupOpeningTime.push(item.get('opening_time').value);
            pickupDate.push(item.get('date').value?.date);
    
            // Check null Opening Time of Pickup
            pickupNullCount1 = pickupOpeningTime.filter(x => x == null).length;
            if(pickupNullCount1 > 0 ){
              this.pickupOpenTimeNull = true;
              isValid = false;
            }else this.pickupOpenTimeNull = false;
    
            // Check null Date of Pickup
            pickupDateCount =  pickupDate.filter(x => x == undefined).length;
            if(pickupDateCount > 0){
              this.pickupDateNull =  true;
              isValid = false;
            }else this.pickupDateNull = false;

    
            if(pickupNullCount1 < 1 && !this.pickupDateNull){
              if(!this.editId){
                for(let i=0; i < pickupOpeningTime.length; i++){
                  let openingTime = new Date();
      
                  // Check Pickup Closing Time goes beyond given date
                  openingTime?.setHours(pickupOpeningTime[i]?.hour, pickupOpeningTime[i]?.minute, 0, 0);

                  let currTime = new Date();
                  this.pickupOpeningTimePast = false;
                  if(pickupDate[i].year == currTime.getFullYear()){
                    if(pickupDate[i].month == currTime.getMonth()+1){
                      if(pickupDate[i].day == currTime.getDate()){
                        // Check past Opening Time of Pickup
                        if(pickupOpeningTime[i].hour < currTime.getHours()){
                          this.pickupOpeningTimePast = true;
                          isValid = false;
                          if(!this.invalidPickupTime.includes(i)) this.invalidPickupTime.push(i);
                        }else if(pickupOpeningTime[i].hour == currTime.getHours()){
                          if(pickupOpeningTime[i].minute < currTime.getMinutes()){
                            this.pickupOpeningTimePast = true;
                            isValid = false;
                            if(!this.invalidPickupTime.includes(i)) this.invalidPickupTime.push(i);
                          }
                          else if(pickupOpeningTime[i].minute >= currTime.getMinutes()){//if time is valid
                            if(this.invalidPickupTime.includes(i)) this.invalidPickupTime = this.invalidPickupTime.filter(el => el != i);
                          }
                        }
                        else if(pickupOpeningTime[i].hour > currTime.getHours()){//if time is valid
                          if(this.invalidPickupTime.includes(i)) this.invalidPickupTime = this.invalidPickupTime.filter(el => el != i);
                        }
                      }
                      else if(pickupDate[i].day > currTime.getDate()){//if date is valid
                        if(this.invalidPickupTime.includes(i)) this.invalidPickupTime = this.invalidPickupTime.filter(el => el != i);
                      }
                    }
                    else if(pickupDate[i].month > currTime.getMonth()+1){//if date is valid
                      if(this.invalidPickupTime.includes(i)) this.invalidPickupTime = this.invalidPickupTime.filter(el => el != i);
                    }
                  }
                  else if(pickupDate[i].year > currTime.getFullYear()){//if date is valid
                    if(this.invalidPickupTime.includes(i)) this.invalidPickupTime = this.invalidPickupTime.filter(el => el != i);
                  }
                }
      
                let dates=[];
                pickupDate.map(item=>{
                  let duplicateDate = dates.find(x=>x.year==item.year && x.month==item.month && x.day==item.day);
      
                  // Check duplicate plan of date and time in Local or Linehaul
                  if(duplicateDate != undefined || duplicateDate != null){
                    let openingTimes=[];
      
                    // Opening Time
                    pickupOpeningTime.map(item=>{
                      let duplicateOpeningTime = openingTimes.filter(x=>{return x.hour==item.hour && x.minute==item.minute});
      
                      openingTimes.push(item);
                      if(duplicateOpeningTime.length){
                        this.duplicatePickupOpeningTime = true;
                        isValid = false;
                      }else this.duplicatePickupOpeningTime = false;
                    });
                  }else{
                    dates.push(item);
                    this.duplicatePickupOpeningTime = false;
                  };
                });
              } else { //edit booking validations
                this.pickupOpeningTimePast = false;

                for(let i=0; i < pickupOpeningTime.length; i++){
                  let openingTime = new Date();
      
                  // Check Pickup Closing Time goes beyond given date
                  openingTime?.setHours(pickupOpeningTime[i]?.hour, pickupOpeningTime[i]?.minute, 0, 0);

                  let dates=[];
                  pickupDate.map(item=>{
                    let duplicateDate = dates.find(x=>x.year==item.year && x.month==item.month && x.day==item.day);
        
                    // Check duplicate plan of date and time in Local or Linehaul
                    if(duplicateDate != undefined || duplicateDate != null){
                      let openingTimes=[];
        
                      // Opening Time
                      pickupOpeningTime.map(item=>{
                        let duplicateOpeningTime = openingTimes.filter(x=>{return x.hour==item.hour && x.minute==item.minute});
        
                        openingTimes.push(item);
                        if(duplicateOpeningTime.length){
                          this.duplicatePickupOpeningTime = true;
                          isValid = false;
                        }else this.duplicatePickupOpeningTime = false;
                      });
                    }else{
                      dates.push(item);
                      this.duplicatePickupOpeningTime = false;
                    };
                  });
                }
              }
            }

          });
    
          dsCtrl.forEach((item) => {
            //sets the closing time equal to opening time as new requirement in issue #686
            item.get('closing_time').setValue(item.get('opening_time').value);

            // Check location for Deliveries
            if (item.controls['street_no'].value || item.controls['street'].value || item.controls['suburb'].value || item.controls['state'].value || item.controls['postal_code'].value) {
              
              if (!item.controls['street'].value || !item.controls['suburb'].value || !item.controls['state'].value || !item.controls['postal_code'].value) {
                isValid = false; this.isIncompleteAddress = true;
              } else{ this.hasDeliveryEndSite = true; } 
            } else if(item.controls['is_tba'].value== true){
              this.hasDeliveryEndSite = true;
            } else{ isValid = false; this.hasDeliveryEndSite = false;}
    
            deliveryOpeningTime.push(item.get('opening_time').value);
            deliveryDate.push(item.get('date').value?.date);
    
            // Check null Opening Time of Delivery
            deliveryNullCount1 = deliveryOpeningTime.filter(x => x == null).length;
            if(deliveryNullCount1 > 0 ){
              this.deliveryOpenTimeNull = true;
              isValid = false;
            }else this.deliveryOpenTimeNull = false;
            
            // Check null Date of Delivery
            deliveryDateCount =  deliveryDate.filter(x => x == undefined).length;
            if(deliveryDateCount > 0){
              this.deliveryDateNull =  true;
              isValid = false;
            }else this.deliveryDateNull = false;
    
            // Check Delivery Closing Time goes beyond given date
            if(deliveryNullCount1 < 1 && !this.deliveryDateNull){
              if(!this.editId){
                for(let i=0; i < deliveryOpeningTime.length; i++){
    
                  let openingTime = new Date();
      
                  // Check Pickup Closing Time goes beyond given date
                  openingTime?.setHours(deliveryOpeningTime[i]?.hour, deliveryOpeningTime[i]?.minute, 0, 0);
      
                  let currTime = new Date();
                  this.deliveryOpeningTimePast = false;
                  // Check set Date against current Date
                  if(deliveryDate[i].year == currTime.getFullYear()){
                    if(deliveryDate[i].month == currTime.getMonth()+1){
                      if(deliveryDate[i].day == currTime.getDate()){
                        // Check past Opening Time of Delivery
                        if(deliveryOpeningTime[i].hour < currTime.getHours()){
                          this.deliveryOpeningTimePast = true;
                          isValid = false;
                          if(!this.invalidDeliveryTime.includes(i)) this.invalidDeliveryTime.push(i);
                        }else if(deliveryOpeningTime[i].hour == currTime.getHours()){
                          if(deliveryOpeningTime[i].minute < currTime.getMinutes()){
                            this.deliveryOpeningTimePast = true;
                            isValid = false;
                            if(!this.invalidDeliveryTime.includes(i)) this.invalidDeliveryTime.push(i);
                          }
                          else if(deliveryOpeningTime[i].minute >= currTime.getMinutes()){//if time is valid
                            if(this.invalidDeliveryTime.includes(i)) this.invalidDeliveryTime = this.invalidDeliveryTime.filter(el => el != i);
                          }
                        }
                        else if(deliveryOpeningTime[i].hour > currTime.getHours()){//if time is valid
                          if(this.invalidDeliveryTime.includes(i)) this.invalidDeliveryTime = this.invalidDeliveryTime.filter(el => el != i);
                        }

                      }
                      else if(deliveryDate[i].day > currTime.getDate()){//if date is valid
                        if(this.invalidDeliveryTime.includes(i)) this.invalidDeliveryTime = this.invalidDeliveryTime.filter(el => el != i);
                      }
                    }
                    else if(deliveryDate[i].month > currTime.getMonth()+1){//if date is valid
                      if(this.invalidDeliveryTime.includes(i)) this.invalidDeliveryTime = this.invalidDeliveryTime.filter(el => el != i);
                    }
                  }
                  else if(deliveryDate[i].year > currTime.getFullYear()){//if date is valid
                    if(this.invalidDeliveryTime.includes(i)) this.invalidDeliveryTime = this.invalidDeliveryTime.filter(el => el != i);
                  }
                }
      
                let dates=[];
                deliveryDate.map(item=>{
                  let duplicateDate = dates.find(x=>x.year==item.year && x.month==item.month && x.day==item.day);
      
                  // Check duplicate plan of date and time in Local or Linehaul
                  if(duplicateDate != undefined || duplicateDate != null){
                    let openingTimes=[];
      
                    // Opening Time
                    deliveryOpeningTime.map(item=>{
                      let duplicateOpeningTime = openingTimes.filter(x=>{return x.hour==item.hour && x.minute==item.minute});
      
                      openingTimes.push(item);
                      if(duplicateOpeningTime.length){
                        this.duplicateDeliveryOpeningTime = true;
                        isValid = false;
                      }else this.duplicateDeliveryOpeningTime = false;
                    });
                  }else{
                    dates.push(item);
                    this.duplicateDeliveryOpeningTime = false;
                  };
                });
              } else {
                this.deliveryOpeningTimePast = false;

                for(let i=0; i < deliveryOpeningTime.length; i++){
    
                  let openingTime = new Date();
      
                  // Check Pickup Closing Time goes beyond given date
                  openingTime?.setHours(deliveryOpeningTime[i]?.hour, deliveryOpeningTime[i]?.minute, 0, 0);
                }
      
                let dates=[];
                deliveryDate.map(item=>{
                  let duplicateDate = dates.find(x=>x.year==item.year && x.month==item.month && x.day==item.day);
      
                  // Check duplicate plan of date and time in Local or Linehaul
                  if(duplicateDate != undefined || duplicateDate != null){
                    let openingTimes=[];
      
                    // Opening Time
                    deliveryOpeningTime.map(item=>{
                      let duplicateOpeningTime = openingTimes.filter(x=>{return x.hour==item.hour && x.minute==item.minute});
      
                      openingTimes.push(item);
                      if(duplicateOpeningTime.length){
                        this.duplicateDeliveryOpeningTime = true;
                        isValid = false;
                      }else this.duplicateDeliveryOpeningTime = false;
                    });
                  }else{
                    dates.push(item);
                    this.duplicateDeliveryOpeningTime = false;
                  };
                });
              }


            }
          });
          
          let hasSameDateTime = false;
          let pickupPrecedesDelivery = false;

          // Check at least a pickup item precedes the delivery items
          for (const pickupControl of psCtrl) {
            const pickupDateControl = pickupControl.get('date');
            const pickupTimeControl = pickupControl.get('opening_time');

            // Handle user input changes in the 'date' and 'opening_time' field of pickup
            pickupDateControl.valueChanges.subscribe(() => {});
            pickupTimeControl.valueChanges.subscribe(() => {});

            const pickupDateTime = this.parseDateTime(pickupDateControl.value, pickupTimeControl.value);

            for (const deliveryControl of dsCtrl) {
              const deliveryDateControl = deliveryControl.get('date');
              const deliveryTimeControl = deliveryControl.get('opening_time');

              // Handle user input changes in the 'date' and 'opening_time' field of delivery
              deliveryDateControl.valueChanges.subscribe(() => {});
              deliveryTimeControl.valueChanges.subscribe(() => {});

              const deliveryDateTime = this.parseDateTime(deliveryDateControl.value, deliveryTimeControl.value);

              if (pickupDateTime.getTime() === deliveryDateTime.getTime()) {
                hasSameDateTime = true;
                isValid = false;
                break; // No need to check further, as we already found items with the same date and time
              }

              if (pickupDateTime < deliveryDateTime) {
                pickupPrecedesDelivery = true;
              }
            }
          }

          this.isPickupDeliveryMatch = hasSameDateTime;
          this.pickupPrecedesDelivery = pickupPrecedesDelivery;
          
          // Check if at least one pickup precedes any delivery
          if (!this.pickupPrecedesDelivery) {
            isValid = false;
          }
      }else{ 
        this.hasDeliveryEndSite = true; 
        this.pickupPrecedesDelivery = true;
        this.isPickupDeliveryMatch = false;
        this.trailerHireDateInvalid = false;
        this.start_endDateInvalid = false;
      }
      

    }else { 
      this.hasDeliveryEndSite = true; 
      this.pickupPrecedesDelivery = true;
      this.isPickupDeliveryMatch = false;
    }

    if (isValid) this.isIncompleteAddress = false;

    //checks if save as template it has to have a template name
    var save_as_template = this.bookingFrm.controls.is_template.value;
    var template_name_input = this.bookingFrm.controls.template_name.value;
    if( save_as_template == true && (template_name_input =='' || template_name_input == null)){
      this.isTemplateNameValid = false;
    }else{
      this.isTemplateNameValid = true;
    };
    //

    return (isValid && this.hasStartSite && this.isServiceTypeValid() && this.bookingFrm.valid && this.isTemplateNameValid);
}

    parseDateTime(date, time) {
      return new Date(
        parseInt(date.date.year),
        parseInt(date.date.month) - 1,
        parseInt(date.date.day),
        parseInt(time.hour),
        parseInt(time.minute)
      );
    }

    drp_trucks: any;
    drp_drivers: any;
    is_ute: boolean = false;
    is_truck : boolean = false;
    driversList = [];
    async setServiceCategory(event, type) {
      let value;
      if(type == 'booking')
        value = event.target.value;
      else if(type == 'edit')
        value = event;
        
        const sCtrl: FormControl = (<any>this.bookingFrm).controls.service_type_id;
        this.serviceTypes.forEach((e: any) => {
            if (e.id == sCtrl.value)
                this.serviceCategoryId = e.service_category_id;
        });
        this.drp_trucks = this.trucks;
        this.drp_drivers = this.drivers;
        this.driversList = this.serviceTypeValueChange(value);

        //get value abbreviation
        if(value){
          this.serviceTypes.forEach((e: any) => {
            if (e.id.toString() == value.toString())
              {value = e.abbreviation;}
          });
        };
        
        switch(value.toString()){
            case this.SERVICE_TYPE_ABBRV.UTE: case this.SERVICE_TYPE_ABBRV.RIGID:{ // UTE 
                this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 1 && data.equipment_subtype_id == null});
                this.is_ute = true; this.is_truck = false;
                break;
            }
            case this.SERVICE_TYPE_ABBRV.TWOTONES:{ // 2T4P
                this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 2 && data.equipment_subtype_id == 6});
                this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id  > 1 });//license is greater than lr
                this.is_ute = false; this.is_truck = true;
                break;
            }
            case this.SERVICE_TYPE_ABBRV.SEMIPM: case this.SERVICE_TYPE_ABBRV.SEMIPM:{ // Semi Primemover  // Semi Primemover with trailer
                this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 3 && data.equipment_subtype_id == 1})
                this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id == 5 || data.license_class_id == 7});//hc or mc
                this.is_ute = false; this.is_truck = true;
                break;
            }
           case this.SERVICE_TYPE_ABBRV.BDPM :case this.SERVICE_TYPE_ABBRV.BDBL:{ // BDBL Primemover // BDBL Primemover with Trailer
                this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 3 && data.equipment_subtype_id == 2})
                this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id == 5 || data.license_class_id == 7});//hc or mc
                this.is_ute = false; this.is_truck = true;
                break;
            }
            case this.SERVICE_TYPE_ABBRV.SIXTONES:{ // 6T8P
                this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 2 && (data.equipment_subtype_id == 7) })
                this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id == 3 || data.license_class_id == 4});//hr or mr
                this.is_ute = false; this.is_truck = true;
                break;
            }
            case this.SERVICE_TYPE_ABBRV.TWELVETONES:{ // 12T14P
                this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 2 && data.equipment_subtype_id == 8})
                this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id == 3 || data.license_class_id == 4});//hr or mr
                this.is_ute = false; this.is_truck = true;
                break;
            }
            case this.SERVICE_TYPE_ABBRV.ROADTRAIN:{ // Road Train

                // Reset in the form of selected trailers when Road Train service
                this.selectedTrailer = [];
                this.onSelectRoadTrainTrailers(this.selectedTrailer);

                this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 3  && data.equipment_subtype_id == 3})
                this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id == 5 || data.license_class_id == 7})//hc or mc
                this.is_ute = false; this.is_truck = true;
                break;
            }
           case this.SERVICE_TYPE_ABBRV.BDPMA: case this.SERVICE_TYPE_ABBRV.BDPMB:{ // BDBL with A trailer // BDBL with B trailer
                this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 3 && (data.equipment_subtype_id == 2 || data.equipment_subtype_id == 3)})
                this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id == 5 || data.license_class_id == 7})//hc or mc
                this.is_ute = false; this.is_truck = true;
                break;
            }
            case this.SERVICE_TYPE_ABBRV.ATRAILER : case this.SERVICE_TYPE_ABBRV.BTRAILER:{
                this.is_truck = false;this.is_ute =false;
            }
            case this.SERVICE_TYPE_ABBRV.TENPALLETS:{ // 10PR
              this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 2 && data.equipment_subtype_id == 10});
              this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id == 3 || data.license_class_id == 4 });//hr or mr
              this.is_ute = false; this.is_truck = true;
              break;
            };
            //Ceres 330
            case this.SERVICE_TYPE_ABBRV.TWOTONNE6P:{ // 2T6P
              this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 2 && data.equipment_subtype_id == 11});
              this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id  > 2 }); //hr or mr
              this.is_ute = false; this.is_truck = true;
              break;
            }
            case this.SERVICE_TYPE_ABBRV.SIXTONNE10P:{ // 6T10P
              this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 2 && (data.equipment_subtype_id == 12) })
              this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id > 2});//hr or mr
              this.is_ute = false; this.is_truck = true;
              break;
            }
            case this.SERVICE_TYPE_ABBRV.EIGHTTTONE12P:{ // 6T10P
              this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 2 && (data.equipment_subtype_id == 13) })
              this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id > 2});//hr or mr
              this.is_ute = false; this.is_truck = true;
              break;
            }
            case this.SERVICE_TYPE_ABBRV.TWELVETONNE12P:{ // 12T12P
              this.drp_trucks = this.drp_trucks.filter(data=>{ return data.equipment_type_id == 2 && data.equipment_subtype_id == 14})
              this.drp_drivers = this.drp_drivers.filter(data=>{ return data.license_class_id > 2 });//hr or mr
              this.is_ute = false; this.is_truck = true;
              break;
            }
            default:{break;};
        }

    }

    initializePerServiceTypeSelect(){
      this.clearValue('truck');
      this.clearValue('trailerA');
      this.clearValue('trailerB');
      this.clearValue('trailerC');
      this.clearValue('trailerD');
      this.clearValue('trailerE');
      this.clearValue('trailerF');
      this.clearValue('driver1');
      this.clearValue('driver2');
  }

  clearValue(frm_ctrl: string){
    switch(frm_ctrl){
        case('service_category'):{
            const sCtrl: FormControl = (<any>this.bookingFrm).controls.service_type_id;
            sCtrl.setValue(null);
            const sCtrl2: FormControl = (<any>this.bookingFrm).controls.truck_id;
            sCtrl2.setValue('');
            const sCtrl3: FormControl = (<any>this.bookingFrm).controls.trailerA_id;
            sCtrl3.setValue('');
            const sCtrl4: FormControl = (<any>this.bookingFrm).controls.trailerB_id;
            sCtrl4.setValue('');
            const sCtrl5: FormControl = (<any>this.bookingFrm).controls.trailerC_id;
            sCtrl5.setValue('');
            const sCtrl6: FormControl = (<any>this.bookingFrm).controls.trailerD_id;
            sCtrl6.setValue('');
            const sCtrl7: FormControl = (<any>this.bookingFrm).controls.trailerE_id;
            sCtrl7.setValue('');
            const sCtrl8: FormControl = (<any>this.bookingFrm).controls.trailerF_id;
            sCtrl8.setValue('');
            this.is_ute = false; this.is_truck = false;
            break;
        };
        case('truck'):{
            //const sCtrl: FormControl = (<any>this.bookingFrm).controls.summary.controls.truck_id;
            //sCtrl.setValue('');
            this.setTruck(0);
            break;
        };
        case('driver1'):{
            //const sCtrl: FormControl = (<any>this.bookingFrm).controls.summary.controls.driver1_id;
            //sCtrl.setValue(0);
            this.setDriver1(null);
            break;
        };
        case('driver2'):{
            //const sCtrl: FormControl = (<any>this.bookingFrm).controls.summary.controls.driver2_id;
            this.setDriver2(null);
            break;
        };
        case('trailerA'):{
            //const sCtrl: FormControl = (<any>this.bookingFrm).controls.summary.controls.a_trailer_id;
            //sCtrl.setValue('');
            this.setTrailerA(0);
            break;
        };
        case('trailerB'):{
            //const sCtrl: FormControl = (<any>this.bookingFrm).controls.summary.controls.b_trailer_id;
            //sCtrl.setValue('');
            //this.b_trailer = null;
            this.setTrailerB(0);
            break;
        };
        case('trailerC'):{
            //const sCtrl: FormControl = (<any>this.bookingFrm).controls.summary.controls.b_trailer2_id;
            //sCtrl.setValue('');
            //this.b_trailer2 = null;
            this.setTrailerC(0);
            break;
        };
        case('trailerD'):{
           //const sCtrl: FormControl = (<any>this.bookingFrm).controls.summary.controls.b_trailer3_id;
            //sCtrl.setValue('');
            //this.b_trailer3 = null;
            this.setTrailerD(0);
            break;
        };
        case('trailerE'):{
            //const sCtrl: FormControl = (<any>this.bookingFrm).controls.summary.controls.b_trailer4_id;
           // sCtrl.setValue('');
           // this.b_trailer4 = null;
            this.setTrailerE(0);

            break;
        };
        case('trailerF'):{
          //const sCtrl: FormControl = (<any>this.bookingFrm).controls.summary.controls.b_trailer4_id;
         // sCtrl.setValue('');
         // this.b_trailer4 = null;
          this.setTrailerF(0);

          break;
      };
        default:break;
    }
    
  }
  
  checkDeliverTBA(): boolean{
    let deliveries = (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.controls;
    let tba = false;
    
    deliveries.forEach(d=>{
      if(d.controls['is_tba'].value){
        tba = true;
      }
    })

    return tba;
  }
  
  public isset(object){
    return (typeof object !=='undefined');
  }

  getChargingMethodID() {
    const cmCtrl = this.bookingFrm.controls.charging_method_id;
    return cmCtrl.value;
  }

  getKlmsHrs(){
    const ctrl_pickup_sites= (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.value;
    const ctrl_delivery_sites= (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.value;
    
    //calculate klms and hrs based on charging method selected (by hourly or by distance)
    if(this.getChargingMethodID()== this.CHARGING_METHOD_ID.DISTANCE || this.getChargingMethodID()== this.CHARGING_METHOD_ID.HOURLY){
      //check type and has no delivery tba set
      if(this.bookingFrm.controls.has_tba.value == 0 && (this.bookingFrm.controls.job_type_id.value == '1' || this.bookingFrm.controls.job_type_id.value == '2'  || this.bookingFrm.controls.job_type_id.value == '4')){
        if(ctrl_pickup_sites[0].lat != null && ctrl_delivery_sites[0].lat != null){//check if has existing pickup and delivery coordinates
          this.getKlmsHrsPerCoordinates();
        }
      };
    };
  }

  public total_klms_hrs :any ;
  public total_other_costs :number = 0; ;
  computeTotalCost(){

    var total_cost = 0;
    var basic_rate = 0;
    var other_cost = 0;
    this.total_other_costs =0;
    const bCtrl = (<any>this.bookingFrm);
    
    const chargingCtrl =  bCtrl.controls.charging_method_id;
    const priceCtrl = bCtrl.controls.price;
    const fuelLevyCtrl = bCtrl.controls.fuel_levy;
    const serviceFeeCtrl = bCtrl.controls.service_fee;
    
    if(priceCtrl.value > 0){
      
      //get basic rate
      basic_rate = this.computeBasicRate(chargingCtrl.value, priceCtrl.value);
      console.log('basic rate', basic_rate);
      
      //get other costs
      this.other_cost_description = '';
      other_cost = this.computeOtherCosts(chargingCtrl.value, basic_rate);
      this.total_other_costs = other_cost;
      console.log('other costs', other_cost);

      //get add fuel levy and deduct service fee
      var fuel_rate = 0;
      var service_fee_rate = 0;
  
      if (fuelLevyCtrl.valid) {
        fuel_rate = ((fuelLevyCtrl.value/100) * basic_rate );
      };
  
      if (serviceFeeCtrl.valid) {
        service_fee_rate = ((serviceFeeCtrl.value/100) * basic_rate );
      }
      
      //return total_cost
      total_cost = basic_rate + fuel_rate;
      total_cost = total_cost + other_cost;
      if(total_cost > 0 && total_cost >= service_fee_rate){
        total_cost = total_cost - service_fee_rate;
      };
    }
    
    if (total_cost){
      bCtrl.controls.total_cost.setValue(total_cost.toFixed(2));
    }
    else { 
      bCtrl.controls.total_cost.setValue(0);
    };

    if (other_cost){
      bCtrl.controls.other_cost.setValue(other_cost.toFixed(2));
    }
    else { 
      bCtrl.controls.other_cost.setValue(0);
    };
  }

  computeBasicRate(charging_method, price){
    var basic_rate = 0;
    const bCtrl = (<any>this.bookingFrm);
    
    switch(charging_method.toString()){
      case this.CHARGING_METHOD_ID.TONNE : {
        basic_rate = price * bCtrl.controls.tonnes.value;break;
      };
      case this.CHARGING_METHOD_ID.PALLETS : {
        basic_rate = price *  bCtrl.controls.pallet.value;break;
      };
      case this.CHARGING_METHOD_ID.LOAD : {
        if(bCtrl.controls.loads.value == 0){
          basic_rate = price * 1;
        }else if(bCtrl.controls.loads.value > 0){
          basic_rate = price * bCtrl.controls.loads.value;
        };
        break;
      };
      case this.CHARGING_METHOD_ID.HOURLY : {
        if (bCtrl.controls.est_total_hours.value < bCtrl.controls.minimum_hours.value)
          basic_rate = price * bCtrl.controls.est_total_hours.value;
        else basic_rate = price * bCtrl.controls.minimum_hours.value;
        console.log(basic_rate);
        break;
      };
      case this.CHARGING_METHOD_ID.DISTANCE : {
        basic_rate = price * bCtrl.controls.total_klms.value;break;
      };
      default : {basic_rate = 0; break;};
    }
    return basic_rate;
  }

  public computed_klms:number = 0;
  public computed_hrs: number = 0;
  async getKlmsHrsPerCoordinates(){
    var plat ='';
    var plng ='';
    var dlat ='';
    var dlng ='';
    var klms, hrs = 0;
    
    const ctrl_pickup_sites= (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.value;
    const ctrl_delivery_sites= (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.value;
    
    //last pickup
    plat = ctrl_pickup_sites[ctrl_pickup_sites.length - 1].lat;
    plng = ctrl_pickup_sites[ctrl_pickup_sites.length - 1].long;

    //first delivery
    dlat = ctrl_delivery_sites[0].lat;
    dlng = ctrl_delivery_sites[0].long;
    
    if(plat != '' && plng != '' && dlat != '' && dlng != ''){
      var coordinates = {plat:plat, plng:plng, dlat: dlat, dlng: dlng};

      await this.bookingsService.getKlmsHrsPerCoordinates(coordinates).toPromise().then(results=>{
        this.total_klms_hrs = results['total_values'];
        hrs = this.total_klms_hrs['total_hours'];
        klms = this.total_klms_hrs['total_klms'];

        if(this.getChargingMethodID()== this.CHARGING_METHOD_ID.DISTANCE){
          this.bookingFrm.controls.total_klms.setValue(klms);this.computed_klms = klms;
        };
    
        if(this.getChargingMethodID()== this.CHARGING_METHOD_ID.HOURLY){
          this.bookingFrm.controls.est_total_hours.setValue(hrs);this.computed_hrs = hrs;
        }
      });
    }
  }

  getTotalPackagingQuantity(): number {
    const ctrl_packagings = <any>this.bookingFrm.controls['packagings'];
    let total: number = 0;

    ctrl_packagings.controls.forEach((e: any) => {
        total = total + Number(e.controls.quantity.value);
    });
    
    return total;
  }

  public other_cost_description: string ='';
  computeOtherCosts(charging_method, basic_rate){

    //resets addin items
    let ca_array = this.bookingFrm.get('addin_items') as FormArray;
    ca_array.clear();
    
    var other_costs = 0;
    const bCtrl = (<any>this.bookingFrm);
    const dgCtrl = bCtrl.controls.dgClass;


    if (this.getJobType() == this.BOOKING_TYPE.LINEHAUL) {
      other_costs += this.getResidentialCost();
      
      if (charging_method === this.CHARGING_METHOD_ID.PALLETS) {
        if (this.serviceCategoryId <= 2)
          other_costs += this.getTailLiftCost();
        if (this.serviceCategoryId === 1)
          other_costs += this.getHandUnloadCost();
      }

      // IF BDBL
      if (this.serviceCategoryId == 3) {
        other_costs += this.getExtraPickupDeliveryCost();
      }
    }
    
    if (this.serviceCategoryId == 3) {  // IF BDBL
      other_costs += this.getTrailerSplitCost();
    }

    // after hours
    other_costs += this.getAfterHoursCost();

    // DG Add-on
    if (dgCtrl.controls.dg_class_id.value != '') {
      other_costs += (basic_rate * this.getDGPercent());

      this.cost_addin_item = null;
      this.cost_addin_item = this.setAddinItemValues(this.cost_addin_item, this.id_dg, 1, null, basic_rate * this.getDGPercent());
      this.addCostAddinItem(this.cost_addin_item);
    }
    
    // if HR || SEMI
    if (this.serviceCategoryId == 1 || this.serviceCategoryId == 2) {
      const ctrl_pickup_sites = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.value;
      const ctrl_delivery_sites = (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.value;
      const ctrl_local_sites = (<any>this.bookingFrm).controls.local_start_sites.controls.addresses.value;
      
      var has_extra_crew = 0;
      
      if(this.getJobType() == 1){
        if(this.localType == 1){
          ctrl_local_sites.forEach((item) => {
            // residential    
            if (item.is_extra_crew) {
              has_extra_crew = 1;
            }
          });     
        }else{
          ctrl_pickup_sites.forEach((item) => {
            // residential    
            if (item.is_extra_crew) {
              has_extra_crew = 1;
            }
          }); 
    
          ctrl_delivery_sites.forEach((item) => {
            // residential    
            if (item.is_extra_crew) {
              has_extra_crew = 1;
            }
          });
        }
      }
      
      if (has_extra_crew == 1 && charging_method == this.CHARGING_METHOD_ID.PALLETS) {
          other_costs+= this.getExtraCrewCost();
      }
    }
    
    return other_costs;
  }

  hasLocalSite(){
    var site_checker = false;
    const bCtrl = (<any>this.bookingFrm).controls;
    if(bCtrl.local_start_sites.controls.addresses.value[0]['lat'] != null && bCtrl.local_start_sites.controls.addresses.value[0]['lat'] != ''){
      site_checker = true;
    } 
    return site_checker;
  }

  hasPickupSite(){
    var site_checker = false;
    const bCtrl = (<any>this.bookingFrm).controls;
    if(bCtrl.pickup_sites.controls.addresses.value[0]['lat'] != null && bCtrl.pickup_sites.controls.addresses.value[0]['lat'] != ''){
      site_checker = true;
    } 
    return site_checker;
  }

  hasDeliverySite(){
    var site_checker = false;
    const bCtrl = (<any>this.bookingFrm).controls;
    if(bCtrl.delivery_sites.controls.addresses.value[0]['lat'] != null && bCtrl.delivery_sites.controls.addresses.value[0]['lat'] != ''){
      site_checker = true;
    } 
    return site_checker;
  }

  getResidentialCost() {
    var cost: number = 0;
    var residential_per_site = 0;
    var unit_count = 0;
    if(this.isset(this.costDefaults)){
      residential_per_site = parseFloat(this.costDefaults.residential_per_site);
    }

    const bCtrl = (<any>this.bookingFrm).controls;
    if(this.hasLocalSite()){
      const ctrl_local_sites= bCtrl.local_start_sites.controls.addresses.value;
   
      ctrl_local_sites.forEach((item) => {
        // residential    
        if (item.is_residential) {
            cost = cost + residential_per_site;
            unit_count ++;
        }
      }); 
    }else{
      const ctrl_pickup_sites= bCtrl.pickup_sites.controls.addresses.value;
      const ctrl_delivery_sites= bCtrl.delivery_sites.controls.addresses.value;
      
      // LOOP THROUGH ALL POINTS
      if(this.hasPickupSite()){
        ctrl_pickup_sites.forEach((item) => {
          // residential    
          if (item.is_residential) {
              cost = cost + residential_per_site;
              unit_count ++;
          }
        }); 
      };

      if(this.hasDeliverySite()){
        ctrl_delivery_sites.forEach((item) => {
          // residential    
          if (item.is_residential) {
              cost = cost + residential_per_site;
              unit_count ++;
          }
        }); 
      }
    };

    console.log('residential', cost);
    if(cost > 0){
      this.other_cost_description = this.other_cost_description + ' <i class="fa fa-sm fa-circle text-warning"></i> residential: ' + cost.toString() ;

      this.cost_addin_item = null;
      this.cost_addin_item = this.setAddinItemValues(this.cost_addin_item, this.id_residential, unit_count, null, cost);
      this.addCostAddinItem(this.cost_addin_item);

    }

    return cost;
    
  }
  
  getTailLiftCost() {
    var cost: number = 0;
    var tail_lift_per_pallet = 0;
    var unit_count = 0;
    if(this.costDefaults){
      tail_lift_per_pallet = parseFloat(this.costDefaults.tail_lift_per_pallet);
    };

    const bCtrl = (<any>this.bookingFrm).controls;
    //const ctrl_pallet = bCtrl.pallet;

    
    if(this.hasLocalSite()){
      const ctrl_local_sites= bCtrl.local_start_sites.controls.addresses.value;
    
      ctrl_local_sites.forEach((item) => {
        if (item.is_tail_lift) {
            // cost = cost + (ctrl_pallet.value * tail_lift_per_pallet);
            cost = cost + tail_lift_per_pallet;
            unit_count ++;
        }
      }); 
    }else{


      const ctrl_pickup_sites= bCtrl.pickup_sites.controls.addresses.value;
      const ctrl_delivery_sites= bCtrl.delivery_sites.controls.addresses.value;
      
      if(this.hasPickupSite()){
        ctrl_pickup_sites.forEach((item) => {
          if (item.is_tail_lift) {
              // cost = cost + (ctrl_pallet.value * tail_lift_per_pallet);
              cost = cost + tail_lift_per_pallet;
              unit_count ++;
          }
        });
      }

      if(this.hasDeliverySite()){
        ctrl_delivery_sites.forEach((item) => {
          if (item.is_tail_lift) {
              // cost = cost + (ctrl_pallet.value * tail_lift_per_pallet);
              cost = cost + tail_lift_per_pallet;
              unit_count ++;
          }
        });
      }
    };

    console.log('tail lift', cost);

    if(cost > 0){
      this.other_cost_description = this.other_cost_description + ' <i class="fa fa-sm fa-circle text-warning"></i> tail lift: ' + cost.toString();

      this.cost_addin_item = null;
      this.cost_addin_item = this.setAddinItemValues(this.cost_addin_item, this.id_tail_lift, unit_count, null, cost);
      this.addCostAddinItem(this.cost_addin_item);

    }


    return cost;
  }

  getHandUnloadCost() {
    var cost: number = 0;
    var hand_unload_per_pallet = 0;
    var unit_count = 0;
    if(this.costDefaults){
      hand_unload_per_pallet = parseFloat(this.costDefaults.hand_unload_per_pallet);
    };

    const bCtrl = (<any>this.bookingFrm).controls;
    const ctrl_pallet = bCtrl.pallet;
    
    if(this.hasLocalSite()){
      const ctrl_local_sites= bCtrl.local_start_sites.controls.addresses.value;
    
      ctrl_local_sites.forEach((item) => {
        if (item.is_hand_unload) {
            cost = cost + (ctrl_pallet.value * hand_unload_per_pallet);
            unit_count ++;
        }
      });
    }else{
      const ctrl_pickup_sites= bCtrl.pickup_sites.controls.addresses.value;
      const ctrl_delivery_sites= bCtrl.delivery_sites.controls.addresses.value;
      
      if(this.hasPickupSite()){
       ctrl_pickup_sites.forEach((item) => {
          if (item.is_hand_unload) {
              cost = cost + (ctrl_pallet.value * hand_unload_per_pallet);
              unit_count ++;
          }
        });
      }

      if(this.hasDeliverySite()){
        ctrl_delivery_sites.forEach((item) => {
          if (item.is_hand_unload) {
              cost = cost + (ctrl_pallet.value * hand_unload_per_pallet);
              unit_count ++;
          }
        });
      }
    };
    console.log('hand unload', cost);

    if(cost > 0){
      this.other_cost_description = this.other_cost_description + ' <i class="fa fa-sm fa-circle text-warning"></i> hand unload: ' + cost.toString();

      this.cost_addin_item = null;
      this.cost_addin_item = this.setAddinItemValues(this.cost_addin_item, this.id_hand_unload, unit_count, null, cost);
      this.addCostAddinItem(this.cost_addin_item);

    }

    return cost;
  }

  getExtraPickupDeliveryCost() {
    var cnt_pickup : number = -1;
    var cnt_delivery: number = -1;
    // var cnt_local: number = -1;
    var unit_count = 0;

    var is_extra: number = 0;
    var cost = 0;

    var extra_pickup_delivery = 0;
    if(this.costDefaults){
      extra_pickup_delivery = parseFloat(this.costDefaults.extra_pickup_delivery);
    };
    
    const bCtrl = (<any>this.bookingFrm).controls;
    
    // if(bCtrl.local_start_sites.controls.addresses.value[0]['lat'] != null){
    //   const ctrl_local_sites= bCtrl.local_start_sites.controls.addresses.value;
    
    //   ctrl_local_sites.forEach((item) => {
    //     cnt_local = cnt_local + 1;
    //   });

    //   cost=(cnt_local) * extra_pickup_delivery;
  
    // }else{
      const ctrl_pickup_sites= bCtrl.pickup_sites.controls.addresses.value;
      const ctrl_delivery_sites= bCtrl.delivery_sites.controls.addresses.value;
      
      if(this.hasPickupSite()){
        ctrl_pickup_sites.forEach((item) => {
            cnt_pickup = cnt_pickup + 1;
            unit_count ++;
        });
      };

      if(this.hasDeliverySite()){
        ctrl_delivery_sites.forEach((item) => {
          cnt_delivery = cnt_delivery + 1;
          unit_count ++;
        });
      }
      
      cost=(cnt_pickup + cnt_delivery) * extra_pickup_delivery;

    // };

    console.log('extra pickup delivery', cost);
    
    if(cost > 0){
      this.other_cost_description = this.other_cost_description + ' <i class="fa fa-sm fa-circle text-warning"></i> extra pickup/delivery: ' + cost.toString();

      this.cost_addin_item = null;
      this.cost_addin_item = this.setAddinItemValues(this.cost_addin_item, this.id_extra_site, unit_count, null, cost);
      this.addCostAddinItem(this.cost_addin_item);

    }


    return cost;
  }

  getTrailerSplitCost() {
    var cost: number = 0;
    var unit_count = 0;

    var bdbl_split_per_site = 0;
    if(this.costDefaults){
      bdbl_split_per_site = parseFloat(this.costDefaults.bdbl_split_per_site);
    };

    const bCtrl = (<any>this.bookingFrm).controls;
    
    if(this.hasLocalSite()){
      const ctrl_local_sites= bCtrl.local_start_sites.controls.addresses.value;
          
      ctrl_local_sites.forEach((item) => {
        if (item.is_trailer_split) {
          cost = cost + bdbl_split_per_site;
          unit_count ++;
        }
      });
    }else{

      const ctrl_pickup_sites= bCtrl.pickup_sites.controls.addresses.value;
      const ctrl_delivery_sites= bCtrl.delivery_sites.controls.addresses.value;

      if(this.hasPickupSite()){
        ctrl_pickup_sites.forEach((item) => {
            if (item.is_trailer_split) {
                cost = cost + bdbl_split_per_site;
                unit_count ++;
            }
        });
      };

      if(this.hasDeliverySite()){
        ctrl_delivery_sites.forEach((item) => {
          if (item.is_trailer_split) {
              cost = cost + bdbl_split_per_site;
              unit_count ++;
          }
        });
      }
    };

    console.log('trailer split', cost);

    if(cost > 0){
      this.other_cost_description = this.other_cost_description + ' <i class="fa fa-sm fa-circle text-warning"></i> trailer split: ' + cost.toString();

      this.cost_addin_item = null;
      this.cost_addin_item = this.setAddinItemValues(this.cost_addin_item, this.id_trailer_split, unit_count, null, cost);
      this.addCostAddinItem(this.cost_addin_item);

    }

    return cost;
  }

  getAfterHoursCost() {
    var cost: number = 0;
    var after_hours_per_site = 0;
    var unit_count = 0;

    if(this.costDefaults){
      after_hours_per_site = parseFloat(this.costDefaults.after_hours_per_site);
    };

    const bCtrl= (<any>this.bookingFrm).controls;
    
    if(this.hasLocalSite()){
      const ctrl_local_sites= bCtrl.local_start_sites.controls.addresses.value;
    
      ctrl_local_sites.forEach((item) =>{ 
        if (item.opening_time.hour >= 17 || item.opening_time.hour < 6) {
          cost = cost + after_hours_per_site;
          unit_count ++;
        }
      });
    }else{
      const ctrl_pickup_sites= bCtrl.pickup_sites.controls.addresses.value;
      const ctrl_delivery_sites= bCtrl.delivery_sites.controls.addresses.value;

      if(this.hasPickupSite()){
        ctrl_pickup_sites.forEach((item) => {
          if (item.opening_time.hour >= 17 || item.opening_time.hour < 6) {
            cost = cost + after_hours_per_site;
            unit_count ++;
          }
        });
      };

      if(this.hasDeliverySite()){
        ctrl_delivery_sites.forEach((item) => {
          if (item.opening_time.hour >= 17 || item.opening_time.hour < 6) {
            cost = cost + after_hours_per_site;
            unit_count ++;
          }
        });
        
      }
    }

    console.log('after hours', cost);

    if(cost > 0){
      this.other_cost_description = this.other_cost_description + ' <i class="fa fa-sm fa-circle text-warning"></i> after hours: ' + cost.toString();

      this.cost_addin_item = null;
      this.cost_addin_item = this.setAddinItemValues(this.cost_addin_item, this.id_after_hours, unit_count, null, cost);
      this.addCostAddinItem(this.cost_addin_item);

    }

    return cost;
  }

  getDGPercent() {
      const dgCtrl = (<any>this.bookingFrm).controls.dgClass;
      var percent: number = 0; 
      
      var dg_packed = 0;
      if(this.costDefaults){
        dg_packed = parseFloat(this.costDefaults.dg_packed);
      };

      var dg_bulk = 0;
      if(this.costDefaults){
        dg_bulk = parseFloat(this.costDefaults.dg_bulk);
      };
  
      if (dgCtrl.controls.dg_type_id.value == '1')
          percent = dg_packed / 100;
      else if (dgCtrl.controls.dg_type_id.value == '2')
          percent = dg_bulk / 100;

      console.log('dg percent', percent);
      
      return percent;
  }

  getExtraCrewCost() {
    const ctrl_pallet = (<any>this.bookingFrm).controls.pallet;
    var cost: number = 0;
    
    var extra_crew_per_pallet = 0;
    if(this.costDefaults){
      extra_crew_per_pallet = parseFloat(this.costDefaults.extra_crew_per_pallet);
    };
    cost = ctrl_pallet.value * extra_crew_per_pallet;
    console.log('extra crew', cost);

    if(cost > 0){
      this.other_cost_description = this.other_cost_description + ' <i class="fa fa-sm fa-circle text-warning"></i> extra crew: ' + cost.toString();

      this.cost_addin_item = null;
      this.cost_addin_item = this.setAddinItemValues(this.cost_addin_item, this.id_extra_crew, 1, null, cost);
      this.addCostAddinItem(this.cost_addin_item);
    }

    return cost;
  }

  checkIntValue(int_value, caller){

    switch(caller){
      case 'service_fee' :{
        if(int_value.target.value > 100){ this.bookingFrm.controls.service_fee.setValue(100);}
        if(int_value.target.value < 0){ this.bookingFrm.controls.service_fee.setValue(0);}
        break;
      }
      case 'fuel_levy' :{
        if(int_value.target.value > 100){ this.bookingFrm.controls.fuel_levy.setValue(100);}
        if(int_value.target.value < 0){ this.bookingFrm.controls.fuel_levy.setValue(0);}
        break;
      }
      case 'price' :{
        if(int_value.target.value < 0){ this.bookingFrm.controls.price.setValue(0);}
        break;
      }
      default:break;
    }
  };

  checkServiceType(connote_id){
    if(connote_id){
      const sCtrl = (<any>this.bookingFrm).controls.service_type_id;
      let svc_exists = this.serviceTypesAllowed.find(x => x.id == sCtrl.value);
      this.serviceTypes.forEach((e: any) => {
          if(svc_exists == undefined && e.id == sCtrl.value){
            this.serviceTypesAllowed.push(e);
            this.serviceTypesAllowed.sort((a, b) => 0 - (a.id > b.id ? -1 : 1));
          };
      });
    }
  }

  setAddinVariables(){
    this.connote_addins.forEach(ca=>{
      
      switch(ca['name']){
        case 'residential' :{ this.id_residential = ca['id'];break;};
        case 'tail_lift' :{ this.id_tail_lift = ca['id'];break;};
        case 'hand_unload' :{ this.id_hand_unload = ca['id'];break;};
        case 'extra_site' :{ this.id_extra_site = ca['id'];break;};
        case 'trailer_split' :{ this.id_trailer_split = ca['id'];break;};
        case 'after_hours' :{ this.id_after_hours = ca['id'];break;};
        case 'dg' :{ this.id_dg = ca['id'];break;};
        case 'extra_crew' :{ this.id_extra_crew = ca['id'];break;};
        default: break;
      }
    });
  }

  setAddinItemValues(obj_addin_item, connote_addin_id, unit, description, cost){
    let connote_id = null;
    if(this.editId){
      connote_id = this.editId;
    };

    var data = {connote_id:connote_id, 
                connote_addin_id: connote_addin_id,
                units: unit, 
                description: description,
                cost: cost,
                created_by: this.user.id}
    
    return data;
  }

  addCostAddinItem(cost_addin_item : CostAddinItem){
    const aCtrl = (<any>this.bookingFrm).controls.addin_items;

    let existing_index =  aCtrl.value.findIndex(x => x.connote_addin_id == cost_addin_item.connote_addin_id);
    
    if(existing_index == -1){
      aCtrl.push(this.initAddinItem());
      let index = aCtrl.length - 1;
      
      aCtrl.controls[index].controls.connote_id.setValue(cost_addin_item['connote_id']);
      aCtrl.controls[index].controls.connote_addin_id.setValue(cost_addin_item['connote_addin_id']);
      aCtrl.controls[index].controls.units.setValue(cost_addin_item['units']);
      aCtrl.controls[index].controls.description.setValue(cost_addin_item['description']);
      aCtrl.controls[index].controls.cost.setValue(cost_addin_item['cost']);
      aCtrl.controls[index].controls.created_by.setValue(cost_addin_item['created_by']);
    }
  }

  clearTime(caller, event){
    console.log(caller, event.target.value);
  }

  checkBusinessHours(siteCtrl){

    if(siteCtrl.lat.value || siteCtrl.long.value){
      let lat = siteCtrl.lat.value;
      let lng = siteCtrl.long.value;

      this.bookingsService.getLocationRecord(lat,lng).subscribe(data=>{console.log(data);
        if(data["business_hours"]!=null){
          let hours = data["business_hours"];
          if(hours['business_open_time']){
            siteCtrl.business_open_time.setValue(hours['business_open_time']);
            siteCtrl.business_close_time.setValue(hours['business_close_time']);
          }else{
            siteCtrl.business_open_time.setValue('');
            siteCtrl.business_close_time.setValue('');
          };
        }else{
          siteCtrl.business_open_time.setValue('');
          siteCtrl.business_close_time.setValue('');
        };        
      });
    }
  }

  setSitePackaging(site_id, p, event){
    
    const p_site_pckg = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls[site_id].controls['packagings'];
    var site_packages = p_site_pckg.value;
    var search_index = null;
    if(site_packages != null  && site_packages !=''){
      search_index = site_packages.map(sp=>sp.packaging_id).indexOf(p.packaging_id);
    }else{
      site_packages = [];
    };
    
    if(event.target.checked == true){
      if(search_index == -1 || search_index == null){
        let pdata = {packaging_id:p.packaging_id, db_id:null};
        site_packages.push(pdata);
      };
    }else{
      if(search_index !=-1){
        site_packages.splice(search_index, 1);
      }
    }
    
    p_site_pckg.setValue(site_packages);
    // this.checkSitePackageOwnership(site_id, p_id);
    
      
  }

  public packaging_id: number =0;
  public plc_packagings: any =[];
  setPackageTypeName(i, event){
    
    const pCtrl = (<any>this.bookingFrm).controls.packagings;

    if(event.target.value !=''){
      let type_name= '';
      this.packagingTypes.forEach(pt=>{
        if(pt.id.toString() == event.target.value){
          type_name = pt.name;
          pCtrl.controls[i].controls['packaging_type_name'].setValue(type_name);
        }
      })
    };
    
    this.plc_packagings = pCtrl.value;
  }

  checkSitePackageOwnership(index_site, packaging_id){
    
    var package_owned = false;
    const ctrl_pickup_sites = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.value;

    if(ctrl_pickup_sites){
      ctrl_pickup_sites.forEach((psite, index)=>{
        let site_pckgs = psite.packagings;
        
        if(site_pckgs != null && site_pckgs != ''){
          let index_site_package = site_pckgs.map(sp=>sp.packaging_id).indexOf(packaging_id);
          if (index_site_package != -1 && index_site != index){
            package_owned = true;
          }
        }
      });
    }
    
    return package_owned;
  }

  removeSitesPackages(packagings, packaging_id){
    if(packagings != null || packagings != ''){
      const ctrl_pickup_sites = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.value;

      if(ctrl_pickup_sites){
        ctrl_pickup_sites.forEach((pSite, index)=>{
          let p_sites = pSite.packagings;
          if(p_sites != null && p_sites != ''){
            let site_p_index = p_sites.map(sp=>sp.packaging_id).indexOf(packaging_id);
            if(site_p_index != -1){
              p_sites.splice(site_p_index,1);
            };
          }
        });
      }
    }
  }

  setPackageCheckedValue(index_site, packaging_db_id){
    var is_checked = false;
    const p_site_pckg = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls[index_site].controls['packagings'].value;
    
    if(p_site_pckg != null && p_site_pckg != ''){
      p_site_pckg.forEach(psp => {
        if(psp['packaging_id'] == packaging_db_id){
          is_checked = true;
        }
      });
    };
    
    return is_checked;
  }

  setSitePackagingEdit(site_id, p, event){
    
    const p_site_pckg = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls[site_id].controls['packagings'];
    var site_packages = p_site_pckg.value;
    var search_index = null;
    if(site_packages != null  && site_packages !=''){
      search_index = site_packages.map(sp=>sp.packaging_id).indexOf(p.packaging_id);
    }else{
      site_packages = [];
    };
    
    if(event.target.checked == true){
      if(search_index == -1 || search_index == null){
        var p_id = null;
        if(p.packaging_id != undefined){
          p_id = p.packaging_id
        }
        let pdata = {packaging_id:p_id, db_id:p.db_id};
        site_packages.push(pdata);
      };
    }else{
      if(search_index !=-1){
        site_packages.splice(search_index, 1);
      }
    }
    
    p_site_pckg.setValue(site_packages);
  }

  modifyFormForTemplate(event){
    if(event.target.checked == true){
      this.bookingFrm.controls.template_name.setValidators(Validators.required);
    }else{
      this.bookingFrm.controls.template_name.clearValidators()
    }
    this.bookingFrm.controls.template_name.updateValueAndValidity();
  }

  setLimitForUnits(){
    let charged_by = this.getChargingMethodID();
    
    switch(charged_by){
      
      case this.CHARGING_METHOD_ID.PALLETS : {
        if(this.bookingFrm.controls.pallet.value == 0){
          this.bookingFrm.controls.pallet.setValue(1);
        };break;
      }

      case this.CHARGING_METHOD_ID.LOAD : {
        if(this.bookingFrm.controls.loads.value == 0){
          this.bookingFrm.controls.loads.setValue(1);
        };break
      }

      case this.CHARGING_METHOD_ID.TONNE : {
        if(this.bookingFrm.controls.tonnes.value == 0){
          this.bookingFrm.controls.tonnes.setValue(1);
        };break
      };
    }
  }

  is_oversized :boolean = false;
  is_pallet : boolean = false;
  public checkPalletDimensions(index){
    this.is_oversized = false;
    this.is_pallet = false;
    const pCtrl = (<any>this.bookingFrm).controls.packagings.controls[index];
    const pallet_type = pCtrl.controls['packaging_type_id'].value;
    let pallet_id = 0;
    let oversized_pallet_id = 0;
    let plainp_id = 0;
    let oversized_plainp_id = 0;
    let chep_id = 0;
    let oversized_chep_id = 0;
    let loscom_id = 0;
    let oversized_loscom_id = 0;
    
      if(this.packagingTypes?.length > 0){
        this.packagingTypes.forEach(pt => {
          
          if(pt.name == this.PACKAGING_TYPE_LABELS.PLAINPALLET){
            plainp_id = pt.id;
          }

          if(pt.name == this.PACKAGING_TYPE_LABELS.OVERPLAINPALLET){
            oversized_plainp_id = pt.id;
          }

          if(pt.name == this.PACKAGING_TYPE_LABELS.CHEPPALLET){
            chep_id = pt.id;
          }

          if(pt.name == this.PACKAGING_TYPE_LABELS.OVERCHEPPALLET){
            oversized_chep_id = pt.id;
          }

          if(pt.name == this.PACKAGING_TYPE_LABELS.LOSCOMPALLET){
            loscom_id = pt.id;
          }

          if(pt.name == this.PACKAGING_TYPE_LABELS.OVERLOSCOMPALLET){
            oversized_loscom_id = pt.id;
          }
        });
      }
      

      //assign to pallet id and oversized pallet id
      if(pallet_type == plainp_id || pallet_type == oversized_plainp_id){
        pallet_id = plainp_id;
        oversized_pallet_id = oversized_plainp_id;
      }

      if(pallet_type == chep_id || pallet_type == oversized_chep_id){
        pallet_id = chep_id;
        oversized_pallet_id = oversized_chep_id;
      }

      if(pallet_type == loscom_id || pallet_type == oversized_loscom_id){
        pallet_id = loscom_id;
        oversized_pallet_id = oversized_loscom_id;
      }
      
    //check dimensions if selected packaging type is either Pallet type or Oversized Palle type
    if(pallet_id !=0 && oversized_pallet_id !=0){console.log(pallet_id, oversized_pallet_id);
      if(pallet_type && (pallet_type == pallet_id || pallet_type == oversized_pallet_id)){
        let max_width = parseFloat(this.costDefaults.pallet_max_width);
        let max_length = parseFloat(this.costDefaults.pallet_max_length);
        let max_height = parseFloat(this.costDefaults.pallet_max_height);
        let max_weight = parseFloat(this.costDefaults.pallet_max_weight);

        if(pallet_type == pallet_id &&
           (parseFloat(pCtrl.controls['length'].value) > max_length ||
            parseFloat(pCtrl.controls['width'].value) > max_width ||
            parseFloat(pCtrl.controls['height'].value) > max_height ||
            parseFloat(pCtrl.controls['weight'].value) > max_weight)  ){
          pCtrl.controls['packaging_type_id'].setValue(oversized_pallet_id);
          this.is_oversized = true;
          this.is_pallet = false;
        };
    
        if(pallet_type == oversized_pallet_id &&
          (parseFloat(pCtrl.controls['length'].value) <= max_length &&
           parseFloat(pCtrl.controls['width'].value) <= max_width &&
           parseFloat(pCtrl.controls['height'].value) <= max_height &&
           parseFloat(pCtrl.controls['weight'].value) <= max_weight) ){
          pCtrl.controls['packaging_type_id'].setValue(pallet_id);
          this.is_pallet = true;
          this.is_oversized = false;
        };    
      }else{
        this.is_pallet = false;
        this.is_oversized = false;
      };
    }
  };

  onSelectPremiseType(pt_index, pt_ctrl, site_type){
    var site = null;
    if(site_type == "pickup"){
      site = (<any>this.bookingFrm).controls.pickup_sites.controls.addresses.controls[pt_index];
    }else{
      if(site_type == "delivery"){
        site = (<any>this.bookingFrm).controls.delivery_sites.controls.addresses.controls[pt_index];
      };
    };
    
    if(site != null){
      if(pt_ctrl.target.value == 1){
        site.controls.is_residential.setValue(1);
      }else{
        site.controls.is_residential.setValue(0);
      }
    };
  };

}
